import React from 'react';
import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';
import { List, Form, Button } from 'semantic-ui-react'
import _ from 'lodash';
import cartaLub from '../../../functions/cartalub';
import cartaLub2 from '../../../functions/cartalub2';

import jsPDF from 'jspdf';
import 'jspdf-autotable';
import XLSX from 'xlsx'
import { saveAs } from 'file-saver';
//utils
import queries from '../../../../src/utils/queries'

import TitDer from '../../../components/funcionales/titder';
import EstaSeg7Btn from '../../../components/funcionales/estaseg7btn';

// import general from '../../modulos/general';

//dropdown EMPRESAS
const DetalleEmpNivel1 = props => {
  return (
    <option dato1={props.elemento.logo}>{props.elemento.descrEmpresa}</option>
  )
};

const ListaEmp = ({styles, list, handleChange}) => {
  const Nivel1Detalle = list.map((elemento, _id) => <DetalleEmpNivel1 styles={styles} elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name="descrEmpresa" id="miLista" onChange={(ev)=>handleChange(ev)}>
        {/* <option value="">Seleccionar Empresa...</option> */}
        {Nivel1Detalle}
      </select>
    </div>
  )
};
//Fin dropdown EMPRESAS

//Lista de mecanismos
const DetallePl = ({elemento}) => {
  return(
    <tr className=''>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrPlanta}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrSeccion}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrEquipo}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrComponente}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrMecanismo}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrAplicacion}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrMetodo}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrTarea}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.modoTarea?elemento.modoTarea:''}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.requiereSISO?elemento.requiereSISO:''}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrFrecuencia}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrLubricante}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.tipoLub}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.puntosLub}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.claseLub}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.categoriaLub}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrGrado}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.tipoGrado}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.apiSAE}</td>

      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>
        {elemento.archRotulo &&
          <img src={elemento.archRotulo} height='50' width='100' alt="Rotulo" />
        }
        {!elemento.archRotulo &&
          ""
        }
      </td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.codigoQR}</td>

    </tr>
  )
};

const ListaPl = ({list}) => {
  const nivel1Detalle = list.map((elemento, i) => <DetallePl elemento={elemento} key={i}/>);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
};
//FIN Lista de mecanismos

class ConfImprCL2 extends React.Component {
  state={listCL: this.props.list, listImg: this.props.list2,
    procBtn: 0, permiteBtn1: true, permiteBtn2: true, confirmaAct: false, open: false
  }

  crudBD = async (operacionCRUD, args, i)=>{
    //ACTUALIZAR BD
    if(args.ctrlCampo === 'CRUD'){
      const {data} = await operacionCRUD({
        variables: args
      });

    //Se utiliza para traer el _id del documento creado
      if(args.ctrl_id === 'SI_ID'){
        if(Object.values(data)[0]._id){
          return Object.values(data)[0]._id
        }else{
          return 0
        }
      }
    }else{
      if(args.ctrlCampo === "MANY"){
        const {data} = await operacionCRUD({
          variables: args
        });
      }
    }
  }

  updColecc = async (crudColecc, argsCrud, totDocCRUD)=>{
    //ENVIO PARA ACTUALIZAR BD
    let codigo = 0
    if(argsCrud[0].ctrl_id === 'SI_ID'){
      codigo = await this.crudBD(crudColecc[0], argsCrud[0], 0)
    }else{
      await this.crudBD(crudColecc[0], argsCrud[0], 0)
    }
    if(codigo!==0){
      for(let i=1; i<totDocCRUD; i++){
        argsCrud[i]._id = codigo
      }
    }

    for(let i=1; i<totDocCRUD; i++){
      await this.crudBD(crudColecc[i], argsCrud[i], i)
    }
  }

//ACTUALIZAR BD
crudBDInd = async (operacionCRUD, args, i)=>{
  if(args.ctrlCampo === 'CRUD'){
    const {data} = await operacionCRUD({
      variables: args
    });

//Se utiliza para traer el _id del documento creado
    if(args.ctrl_id === 'SI_ID'){
      if(Object.values(data)[0]._id){
        return Object.values(data)[0]._id
      }else{
        return 0
      }
    }
  }else{
    if(args.ctrlCampo === "MANY"){
      const {data} = await operacionCRUD({
        variables: args
      });
    }
  }
}

//ENVIO PARA ACTUALIZAR BD
updColeccInd = async (crudColecc, argsCrud, totDocCRUD)=>{
  let codigo = 0
  if(argsCrud[0].ctrl_id === 'SI_ID'){
    codigo = await this.crudBDInd(crudColecc[0], argsCrud[0], 0)
  }else{
    await this.crudBDInd(crudColecc[0], argsCrud[0], 0)
  }
  if(codigo!==0){
    for(let i=1; i<totDocCRUD; i++){
      argsCrud[i]._id = codigo
    }
  }
  for(let i=1; i<totDocCRUD; i++){
    await this.crudBDInd(crudColecc[i], argsCrud[i], i)
  }
}


  crearLinea = (tipo, subTipo, usuario, creado, desde, hasta, descrPlanta, descrSeccion, descrEquipo, descrComponente, 
  descrMecanismo, tipoLub, descrLubricante, descrUnidad, descrMetodo, descrTarea, descrAplicacion, tipoHallazgo, 
  color, modo, riesgo, cantTotal, cantMensual, cantAnual, puntos, minutos)=>{
  let lineaReturn={
    tipo: tipo,
    subTipo: subTipo,
    usuario: usuario,
    creado: creado,
    desde: desde,
    hasta: hasta,
    descrPlanta: descrPlanta,
    descrSeccion: descrSeccion,
    descrEquipo: descrEquipo,
    descrComponente: descrComponente,
    descrMecanismo: descrMecanismo,
    tipoLub: tipoLub,
    descrLubricante: descrLubricante,
    descrUnidad: descrUnidad,
    descrMetodo: descrMetodo,
    descrTarea: descrTarea,
    descrAplicacion: descrAplicacion,
    tipoHallazgo: tipoHallazgo,
    color: color,
    modo: modo,
    riesgo: riesgo,
    cantTotal: cantTotal,
    cantMensual: cantMensual,
    cantAnual: cantAnual,
    puntos: puntos,
    minutos: minutos
  }
  return lineaReturn
}



  handleAnexos = async (ev, list, args)=>{
    console.log(args)
    if(list.length>0){
      let lubricantes = [], lubricantes1 = [], lubricantesEx = [], lubricantesEx1 = [] 
      let tareas = [], tareas1 = [], tareasEx = [], tareasEx1 = []
      let protectores=[], protectores1=[], protectoresEx=[], protectoresEx1=[] 
      let aceiteras=[], aceiteras1=[], aceiterasEx=[], aceiterasEx1=[]
      let modo=[], modo1=[], modoEx=[], modoEx1=[]
      let siso=[], siso1=[], sisoEx=[], sisoEx1=[]

      let unidad = ""
      let allFrecuencia = this.props.allFrecuencia.allFrecuencia
      let allAplicacion = this.props.allAplicacion.allAplicacion
      let allUsuarios = this.props.allUsuarios.allUsuarios
      let allEmpresaRtes = this.props.allEmpresaRtes.allEmpresaRtes

      let nombreUsuario = ''
      let indexUsu = allUsuarios.findIndex( usuario => usuario.email===localStorage.getItem('userLogin') )
      if(indexUsu!==-1){
        nombreUsuario=allUsuarios[indexUsu].nombreUsuario
      }
      let idEmpresa = ''
      let indexEmp = allEmpresaRtes.findIndex( empresa => empresa.descrEmpresa===args.descrEmpresa )
      if(indexEmp!==-1){
        idEmpresa=allEmpresaRtes[indexEmp]._id
      }
      let reportes=[]
      let argsLinea=[]
      let actEmpresa = [], actEmpresaMany = [], actEmpresaMany1 = []
      let argsUpdEmp = {}

      let argsBuscar=""
      argsBuscar += `'descrEmpresa': '${args.descrEmpresa}'`
      if(args.descrPlanta){
        argsBuscar += `, 'descrPlanta': /${args.descrPlanta}/i`
      }
      if(args.descrSeccion){
        argsBuscar += `, 'descrSeccion': /${args.descrSeccion}/i`
      }
      if(args.descrEquipo){
        argsBuscar += `, 'descrEquipo': /${args.descrEquipo}/i`
      }
      if(args.descrComponente){
        argsBuscar += `, 'descrComponente': /${args.descrComponente}/i`
      } 

      let response = await this.props.fecha({
        variables: {}
      });
      const {fechaHoraHoy} = response.data.fecha

// ***** ARMAR ARRAY DE LUBRICANTES ***************************

      let argsBuscarPl = {tipoqry: `[
        {"$unwind": "$secciones"},
        {"$unwind": "$secciones.equipos"},
        {"$unwind": "$secciones.equipos.componentes"},
        {"$unwind": "$secciones.equipos.componentes.mecanismos"},
        {$project: {_id: 1,
          descrEmpresa: 1, codPlanta: 1, descrPlanta: 1,
          codSeccion: '$secciones.codSeccion', descrSeccion: '$secciones.descrSeccion',
          codEquipo: '$secciones.equipos.codEquipo', descrEquipo: '$secciones.equipos.descrEquipo',
          codComponente: '$secciones.equipos.componentes.codComponente',
          descrComponente: '$secciones.equipos.componentes.descrComponente',
          descrMecanismo: '$secciones.equipos.componentes.mecanismos.descrMecanismo',
          tipoLub: '$secciones.equipos.componentes.mecanismos.tipoLub',
          descrLubricante: '$secciones.equipos.componentes.mecanismos.descrLubricante'
        }}, {$match: {${argsBuscar}}}, 
        {$group: {_id: {tipoLub: '$tipoLub', descrLubricante: '$descrLubricante'}}},
        {$project: {tipoLub: '$_id.tipoLub', descrLubricante: '$_id.descrLubricante'}},
          {$sort: {tipoLub: 1, descrLubricante: 1}}]`}

      let {data} = await this.props.allPlantaRtes3.refetch(argsBuscarPl)
      let estructura = await data.allPlantaRtes

      if(estructura.length>0){       
        document.body.style.cursor = 'wait' 
        for(let ii=0; ii<estructura.length; ii++){
          if(estructura[ii].tipoLub==='Aceite'){
            unidad='Galones'
          }else{
            if(estructura[ii].tipoLub==='Grasa'){
              unidad='Kilos'
            }else{
              unidad='Unidad'
            }
          }
          lubricantes1 = [{tipo:estructura[ii].tipoLub, lubricante:estructura[ii].descrLubricante, unidad:unidad, total:0, mensual:0, anual:0}]
          lubricantes.push(lubricantes1)
        }


// ***** ARMAR ARRAY DE TAREAS ***************************

        let argsBuscarPl = {tipoqry: `[
          {"$unwind": "$secciones"},
          {"$unwind": "$secciones.equipos"},
          {"$unwind": "$secciones.equipos.componentes"},
          {"$unwind": "$secciones.equipos.componentes.mecanismos"},
          {"$unwind": "$secciones.equipos.componentes.mecanismos.programacion"},
          {$project: {_id: 1,
            descrEmpresa: 1, descrPlanta: 1,
            descrSeccion: '$secciones.descrSeccion',
            descrEquipo: '$secciones.equipos.descrEquipo',
            descrComponente: '$secciones.equipos.componentes.descrComponente',
            descrMecanismo: '$secciones.equipos.componentes.mecanismos.descrMecanismo',
            descrTarea: '$secciones.equipos.componentes.mecanismos.programacion.descrTarea'
          }}, {$match: {${argsBuscar}}}, 
          {$group: {_id: {descrTarea: '$descrTarea'}}},
          {$project: {descrTarea: '$_id.descrTarea'}},
            {$sort: {descrTarea: 1}}]`}

        if(2>1){
          let {data} = await this.props.allPlantaRtes3.refetch(argsBuscarPl)
          let estructura1 = await data.allPlantaRtes

          for(let ii=0; ii<estructura1.length; ii++){
            tareas1 = [{tarea:estructura1[ii].descrTarea, total:0, mensual:0, anual:0}]
            tareas.push(tareas1)
          }
        }
        // console.log(tareas)

// ***** ARMAR ARRAY DE I / O ***************************

            modo1 = [{modo:'Operando', total:0, mensual:0, anual:0}]
            modo.push(modo1)
            modo1 = [{modo:'En parada', total:0, mensual:0, anual:0}]
            modo.push(modo1)

// ***** ARMAR ARRAY DE SISO ***************************

            siso1 = [{siso:'Requiere SISO', total:0, mensual:0, anual:0}]
            siso.push(siso1)
            siso1 = [{siso:'No requiere SISO', total:0, mensual:0, anual:0}]
            siso.push(siso1)



// ***** VOLUMEN TOTAL DE LUBRICANTES: ***************************

        argsBuscarPl = {tipoqry: `[
          {"$unwind": "$secciones"},
          {"$unwind": "$secciones.equipos"},
          {"$unwind": "$secciones.equipos.componentes"},
          {"$unwind": "$secciones.equipos.componentes.mecanismos"},
          {$project: {_id: 1,
            descrEmpresa: 1, codPlanta: 1, descrPlanta: 1,
            codSeccion: '$secciones.codSeccion', descrSeccion: '$secciones.descrSeccion',
            codEquipo: '$secciones.equipos.codEquipo', descrEquipo: '$secciones.equipos.descrEquipo',
            codComponente: '$secciones.equipos.componentes.codComponente',
            descrComponente: '$secciones.equipos.componentes.descrComponente',
            descrMecanismo: '$secciones.equipos.componentes.mecanismos.descrMecanismo',
            tipoLub: '$secciones.equipos.componentes.mecanismos.tipoLub',
            descrLubricante: '$secciones.equipos.componentes.mecanismos.descrLubricante',
            descrUnidad: '$secciones.equipos.componentes.mecanismos.descrUnidad',
            cantidadTotal: '$secciones.equipos.componentes.mecanismos.cantidadTotal'
          }}, {$match: {${argsBuscar}}}, 
          {$group: {_id: {tipoLub: '$tipoLub', descrLubricante: '$descrLubricante', descrUnidad: '$descrUnidad'},
                    totalCantidad: {$sum: {$toDouble: '$cantidadTotal'}}}},
          {$project: {tipoLub: '$_id.tipoLub', descrLubricante: '$_id.descrLubricante', 
          descrUnidad: '$_id.descrUnidad', ultInforme: {$toDouble: '$totalCantidad'}}},
            {$sort: {tipoLub: 1, descrLubricante: 1, descrUnidad: 1}}]`}
  
        if(2>1){
          let {data} = await this.props.allPlantaRtes3.refetch(argsBuscarPl)
          let estructura1 = await data.allPlantaRtes
          // console.log(estructura1)
          for(let ii=0; ii<estructura1.length; ii++){
            let nomLub = estructura1[ii].descrLubricante
            let indexLub = 0
            lubricantes.forEach(async (elemento, iii) => {
              if(lubricantes[iii][0].lubricante===nomLub){
                indexLub = iii
              }
            })
            
            if(estructura1[ii].tipoLub==='Aceite'){
              if(estructura1[ii].descrUnidad==='Galón' || estructura1[ii].descrUnidad==='Galon' || estructura1[ii].descrUnidad==='galón' || estructura1[ii].descrUnidad==='galon'){
                lubricantes[indexLub][0].total=lubricantes[indexLub][0].total + estructura1[ii].ultInforme
              }else{ 
                switch(estructura1[ii].descrUnidad){
                  case 'Litros':
                    lubricantes[indexLub][0].total=lubricantes[indexLub][0].total + estructura1[ii].ultInforme*0.264;
                    break
                  case 'Mililitro':
                    lubricantes[indexLub][0].total=lubricantes[indexLub][0].total + estructura1[ii].ultInforme*0.00264;
                    break
                  case 'Onza':
                    lubricantes[indexLub][0].total=lubricantes[indexLub][0].total + estructura1[ii].ultInforme*0.0078125;
                    break
                  case 'Gramos':
                    lubricantes[indexLub][0].total=lubricantes[indexLub][0].total + estructura1[ii].ultInforme/3657.14826;
                  break
                }
              }
            }else{
              if(estructura1[ii].tipoLub==='Grasa'){
                if(estructura1[ii].descrUnidad==='Gramos' || estructura1[ii].descrUnidad==='gramos'){
                  lubricantes[indexLub][0].total=lubricantes[indexLub][0].total + estructura1[ii].ultInforme/1000
                }else{
                  switch(estructura1[ii].descrUnidad){
                    case 'Onza':
                      lubricantes[indexLub][0].total=lubricantes[indexLub][0].total + estructura1[ii].ultInforme*0.0283495;
                      break
                    case 'Mililitro':
                      lubricantes[indexLub][0].total=lubricantes[indexLub][0].total + estructura1[ii].ultInforme/1000;
                      break
                    case 'Litros':
                      lubricantes[indexLub][0].total=lubricantes[indexLub][0].total + estructura1[ii].ultInforme;
                      break
                  }
                }
              }else{

              }
            }
            lubricantes[indexLub][0].total=parseFloat(lubricantes[indexLub][0].total).toFixed(1)
          }
        }


// ***** CONSUMO DE LUBRICANTES POR MES Y AÑO ***************************

        argsBuscarPl = {tipoqry: `[
          {"$unwind": "$secciones"},
          {"$unwind": "$secciones.equipos"},
          {"$unwind": "$secciones.equipos.componentes"},
          {"$unwind": "$secciones.equipos.componentes.mecanismos"},
          {"$unwind": "$secciones.equipos.componentes.mecanismos.programacion"},
          {$match: {'secciones.equipos.componentes.mecanismos.programacion.cantidad': {$ne: ""}}},
          {$project: {_id: 1,
            descrEmpresa: 1, codPlanta: 1, descrPlanta: 1,
            codSeccion: '$secciones.codSeccion', descrSeccion: '$secciones.descrSeccion',
            codEquipo: '$secciones.equipos.codEquipo', descrEquipo: '$secciones.equipos.descrEquipo',
            codComponente: '$secciones.equipos.componentes.codComponente',
            descrComponente: '$secciones.equipos.componentes.descrComponente',
            descrMecanismo: '$secciones.equipos.componentes.mecanismos.descrMecanismo',
            tipoLub: '$secciones.equipos.componentes.mecanismos.tipoLub',
            descrLubricante: '$secciones.equipos.componentes.mecanismos.descrLubricante',
            descrUnidad: '$secciones.equipos.componentes.mecanismos.descrUnidad',
            descrFrecuencia: '$secciones.equipos.componentes.mecanismos.programacion.descrFrecuencia',
            descrFrecuenciaPre: '$secciones.equipos.componentes.mecanismos.programacion.descrFrecuenciaPre',
            cantidad: '$secciones.equipos.componentes.mecanismos.programacion.cantidad'
          }}, {$match: {${argsBuscar}}}, 
          {$group: {_id: {tipoLub: '$tipoLub', descrLubricante: '$descrLubricante', 
                    descrUnidad: '$descrUnidad', descrFrecuencia: '$descrFrecuencia', 
                    descrFrecuenciaPre: '$descrFrecuenciaPre'},
                    totalCantidad: {$sum: {$toDouble: '$cantidad'}}}},
          {$project: {tipoLub: '$_id.tipoLub', descrLubricante: '$_id.descrLubricante', 
          descrFrecuencia: '$_id.descrFrecuencia', descrFrecuenciaPre: '$_id.descrFrecuenciaPre',
          descrUnidad: '$_id.descrUnidad', ultInforme: {$toDouble: '$totalCantidad'}}},
            {$sort: {tipoLub: 1, descrLubricante: 1, descrUnidad: 1}}]`}

        if(2>1){
          console.log(argsBuscarPl)
          let {data} = await this.props.allPlantaRtes3.refetch(argsBuscarPl)
          let estructura1 = await data.allPlantaRtes
          // console.log(estructura1)
          for(let ii=0; ii<estructura1.length; ii++){
            let nomLub = estructura1[ii].descrLubricante
            let indexLub = 0
            lubricantes.forEach(async (elemento, iii) => {
              if(lubricantes[iii][0].lubricante===nomLub){
                indexLub = iii
              }
            })
            let cantidadLub=0
            if(estructura1[ii].tipoLub==='Aceite'){
              if(estructura1[ii].descrUnidad==='Galón' || estructura1[ii].descrUnidad==='Galon' || estructura1[ii].descrUnidad==='galón' || estructura1[ii].descrUnidad==='galon'){
                cantidadLub = estructura1[ii].ultInforme
              }else{
                switch(estructura1[ii].descrUnidad){
                  case 'Litros':
                    cantidadLub = estructura1[ii].ultInforme*0.264;
                    break
                  case 'Mililitro':
                    cantidadLub = estructura1[ii].ultInforme*0.00264;
                    break
                  case 'Onza':
                    cantidadLub = estructura1[ii].ultInforme*0.0078125;
                    break
                  case 'Gramos':
                    cantidadLub = estructura1[ii].ultInforme/3657.14826;
                  break
                }
              }
            }else{
              if(estructura1[ii].tipoLub==='Grasa'){
                if(estructura1[ii].descrUnidad==='Gramos' || estructura1[ii].descrUnidad==='gramos'){
                  cantidadLub = estructura1[ii].ultInforme/1000
                }else{
                  switch(estructura1[ii].descrUnidad){
                    case 'Onza':
                      cantidadLub = estructura1[ii].ultInforme*0.0283495;
                      break
                    case 'Mililitro':
                      cantidadLub = estructura1[ii].ultInforme/1000;
                      break
                    case 'Litros':
                      cantidadLub = estructura1[ii].ultInforme;
                      break
                  }
                }
              }else{

              }
            }
            if(cantidadLub>0){
              let cantidadMes=0
              let cantidadAnual=0
              let indexFrec = -1
              if(estructura1[ii].descrFrecuencia==='Predictiva'){
                indexFrec = allFrecuencia.findIndex( frecuencia => frecuencia.descrFrecuencia===estructura1[ii].descrFrecuenciaPre )
              }else{
                indexFrec = allFrecuencia.findIndex( frecuencia => frecuencia.descrFrecuencia===estructura1[ii].descrFrecuencia )
              }
              if(indexFrec!==-1){
                if(allFrecuencia[indexFrec].tipoFrecuencia!=='Km'){
                  if(allFrecuencia[indexFrec].tipoFrecuencia==='Calendario'){
                    cantidadMes=(cantidadLub*30)/allFrecuencia[indexFrec].cantidad
                    cantidadAnual=(cantidadLub*360)/allFrecuencia[indexFrec].cantidad
                  }else{
                    cantidadMes=(cantidadLub*720)/allFrecuencia[indexFrec].cantidad
                    cantidadAnual=(cantidadLub*8640)/allFrecuencia[indexFrec].cantidad
                  }
                }
              }
              lubricantes[indexLub][0].mensual=lubricantes[indexLub][0].mensual + cantidadMes
              lubricantes[indexLub][0].anual=lubricantes[indexLub][0].anual + cantidadAnual
              
            }
            lubricantes[indexLub][0].mensual=parseFloat(lubricantes[indexLub][0].mensual).toFixed(1)
            lubricantes[indexLub][0].anual=parseFloat(lubricantes[indexLub][0].anual).toFixed(1)
          }
          console.log(lubricantes)
          // lubricantes.forEach((elemento2, ii) => {
          //   argsLinea=this.crearLinea('ANEXOS','CONSUMO DE LUBRICANTES',nombreUsuario,'','','','','','','','',elemento2[0].tipo,elemento2[0].lubricante,elemento2[0].unidad,'','','','','','','',parseFloat(elemento2[0].total).toFixed(1),parseFloat(elemento2[0].mensual).toFixed(1),parseFloat(elemento2[0].anual).toFixed(1),0,0)
          //   reportes.push(argsLinea)
          // })
        }

        // ***** CANTIDAD DE PROTECTORES POR ESPESANTE ***************************

        argsBuscarPl = {tipoqry: `[
          {"$unwind": "$secciones"},
          {"$unwind": "$secciones.equipos"},
          {"$unwind": "$secciones.equipos.componentes"},
          {"$unwind": "$secciones.equipos.componentes.mecanismos"},
          {$match: {'secciones.equipos.componentes.mecanismos.tipoLub': 'Grasa'}},
          {$project: {_id: 1,
            descrEmpresa: 1, codPlanta: 1, descrPlanta: 1,
            codSeccion: '$secciones.codSeccion', descrSeccion: '$secciones.descrSeccion',
            codEquipo: '$secciones.equipos.codEquipo', descrEquipo: '$secciones.equipos.descrEquipo',
            codComponente: '$secciones.equipos.componentes.codComponente',
            descrComponente: '$secciones.equipos.componentes.descrComponente',
            descrMecanismo: '$secciones.equipos.componentes.mecanismos.descrMecanismo',
            descrAplicacion: '$secciones.equipos.componentes.mecanismos.descrAplicacion'
          }}, {$match: {${argsBuscar}}}, 
          {$group: {_id: {descrAplicacion: '$descrAplicacion'}, count: { $sum: 1 }}},
          {$project: {descrAplicacion: '$_id.descrAplicacion', ultInforme: {$toInt: '$count'}}},
            {$sort: {descrAplicacion: 1}}]`}

        if(2>1){
          let {data} = await this.props.allPlantaRtes3.refetch(argsBuscarPl)
          let estructura1 = await data.allPlantaRtes
          for(let ii=0; ii<estructura1.length; ii++){
            let indexAp = allAplicacion.findIndex( aplicacion => aplicacion.descrAplicacion===estructura1[ii].descrAplicacion )
            if(indexAp!==-1){
              protectores1 = [{color:allAplicacion[indexAp].color, espesante:estructura1[ii].descrAplicacion, puntos:estructura1[ii].ultInforme, graseras: 1}]
              protectores.push(protectores1)
              // console.log(protectores)
            }
          }
        }

        // protectores.forEach((elemento2, ii) => {
        //   console.log(elemento2)
        //   argsLinea=this.crearLinea('ANEXOS','PROTECTORES Y PISTOLAS ENGRASADORAS',nombreUsuario,'','','','','','','','','','','','','',elemento2[0].espesante,'',elemento2[0].color,'','',elemento2[0].graseras,0,0,elemento2[0].puntos,0)
        //   reportes.push(argsLinea)
        // })

        // ***** CANTIDAD DE ACEITERAS POR APLICACION ***************************

        argsBuscarPl = {tipoqry: `[
          {"$unwind": "$secciones"},
          {"$unwind": "$secciones.equipos"},
          {"$unwind": "$secciones.equipos.componentes"},
          {"$unwind": "$secciones.equipos.componentes.mecanismos"},
          {$match: {'secciones.equipos.componentes.mecanismos.tipoLub': 'Aceite'}},
          {$project: {_id: 1,
            descrEmpresa: 1, codPlanta: 1, descrPlanta: 1,
            codSeccion: '$secciones.codSeccion', descrSeccion: '$secciones.descrSeccion',
            codEquipo: '$secciones.equipos.codEquipo', descrEquipo: '$secciones.equipos.descrEquipo',
            codComponente: '$secciones.equipos.componentes.codComponente',
            descrComponente: '$secciones.equipos.componentes.descrComponente',
            descrMecanismo: '$secciones.equipos.componentes.mecanismos.descrMecanismo',
            descrAplicacion: '$secciones.equipos.componentes.mecanismos.descrAplicacion'
          }}, {$match: {${argsBuscar}}}, 
          {$group: {_id: {descrAplicacion: '$descrAplicacion'}, count: { $sum: 1 }}},
          {$project: {descrAplicacion: '$_id.descrAplicacion', ultInforme: {$toInt: '$count'}}},
            {$sort: {descrAplicacion: 1}}]`}

        if(2>1){
          let {data} = await this.props.allPlantaRtes3.refetch(argsBuscarPl)
          let estructura1 = await data.allPlantaRtes
          for(let ii=0; ii<estructura1.length; ii++){
            let indexAp = allAplicacion.findIndex( aplicacion => aplicacion.descrAplicacion===estructura1[ii].descrAplicacion )
            if(indexAp!==-1){
              aceiteras1 = [{color:allAplicacion[indexAp].color, aplicacion:estructura1[ii].descrAplicacion, puntos:estructura1[ii].ultInforme, aceiteras: 1}]
              aceiteras.push(aceiteras1)
              // console.log(aceiteras)
            }
          }
        }

        // aceiteras.forEach((elemento2, ii) => {
        //   console.log(elemento2)
        //   argsLinea=this.crearLinea('ANEXOS','ACEITERAS',nombreUsuario,'','','','','','','','','','','','','',elemento2[0].aplicacion,'',elemento2[0].color,'','',elemento2[0].aceiteras,0,0,elemento2[0].puntos,0)
        //   reportes.push(argsLinea)
        // })


        // ***** HORAS HOMBRE POR TAREA POR MES Y AÑO ***************************

        argsBuscarPl = {tipoqry: `[
          {"$unwind": "$secciones"},
          {"$unwind": "$secciones.equipos"},
          {"$unwind": "$secciones.equipos.componentes"},
          {"$unwind": "$secciones.equipos.componentes.mecanismos"},
          {"$unwind": "$secciones.equipos.componentes.mecanismos.programacion"},
          {$match: {'secciones.equipos.componentes.mecanismos.programacion.minutos': {$ne: ""}}},
          {$project: {_id: 1,
            descrEmpresa: 1, codPlanta: 1, descrPlanta: 1,
            codSeccion: '$secciones.codSeccion', descrSeccion: '$secciones.descrSeccion',
            codEquipo: '$secciones.equipos.codEquipo', descrEquipo: '$secciones.equipos.descrEquipo',
            codComponente: '$secciones.equipos.componentes.codComponente',
            descrComponente: '$secciones.equipos.componentes.descrComponente',
            descrMecanismo: '$secciones.equipos.componentes.mecanismos.descrMecanismo',
            descrTarea: '$secciones.equipos.componentes.mecanismos.programacion.descrTarea',
            descrFrecuencia: '$secciones.equipos.componentes.mecanismos.programacion.descrFrecuencia',
            descrFrecuenciaPre: '$secciones.equipos.componentes.mecanismos.programacion.descrFrecuenciaPre',
            minutos: '$secciones.equipos.componentes.mecanismos.programacion.minutos'
          }}, {$match: {${argsBuscar}}}, 
          {$group: {_id: {descrTarea: '$descrTarea', descrFrecuencia: '$descrFrecuencia', 
                    descrFrecuenciaPre: '$descrFrecuenciaPre'},
                    totalCantidad: {$sum: {$toDouble: '$minutos'}}}},
          {$project: {descrTarea: '$_id.descrTarea', 
          descrFrecuencia: '$_id.descrFrecuencia', descrFrecuenciaPre: '$_id.descrFrecuenciaPre',
          ultInforme: {$toDouble: '$totalCantidad'}}},
            {$sort: {descrTarea: 1}}]`}

        if(2>1){
          let {data} = await this.props.allPlantaRtes3.refetch(argsBuscarPl)
          let estructura1 = await data.allPlantaRtes
          // console.log(estructura1)
          for(let ii=0; ii<estructura1.length; ii++){
            let nomTa = estructura1[ii].descrTarea
            let indexTa = -1
            // console.log(tareas)
            // console.log(nomTa)
            tareas.forEach(async (elemento, iii) => {
              if(tareas[iii][0].tarea===nomTa){
                indexTa = iii
              }
            })
            // console.log(indexTa)
            let cantidadHoras=0
            if(indexTa!==-1 && estructura1[ii].ultInforme>0){
              cantidadHoras=estructura1[ii].ultInforme/60
              let cantidadMes=0
              let cantidadAnual=0
              let indexFrec = -1
              if(estructura1[ii].descrFrecuencia==='Predictiva'){
                indexFrec = allFrecuencia.findIndex( frecuencia => frecuencia.descrFrecuencia===estructura1[ii].descrFrecuenciaPre )
              }else{
                indexFrec = allFrecuencia.findIndex( frecuencia => frecuencia.descrFrecuencia===estructura1[ii].descrFrecuencia )
              }
              if(indexFrec!==-1){
                if(allFrecuencia[indexFrec].tipoFrecuencia!=='Km'){
                  if(allFrecuencia[indexFrec].tipoFrecuencia==='Calendario'){
                    cantidadMes=(cantidadHoras*30)/allFrecuencia[indexFrec].cantidad
                    cantidadAnual=(cantidadHoras*360)/allFrecuencia[indexFrec].cantidad
                  }else{
                    cantidadMes=(cantidadHoras*720)/allFrecuencia[indexFrec].cantidad
                    cantidadAnual=(cantidadHoras*8640)/allFrecuencia[indexFrec].cantidad
                  }
                }
              }
              tareas[indexTa][0].mensual=tareas[indexTa][0].mensual + cantidadMes
              tareas[indexTa][0].anual=tareas[indexTa][0].anual + cantidadAnual
              // console.log(tareas)
            }
            tareas[indexTa][0].mensual=parseFloat(tareas[indexTa][0].mensual).toFixed(1)
            tareas[indexTa][0].anual=parseFloat(tareas[indexTa][0].anual).toFixed(1)
          }
        }

        // tareas.forEach((elemento2, ii) => {
        //   console.log(elemento2)
        //   argsLinea=this.crearLinea('ANEXOS','HORAS-HOMBRE POR TAREA',nombreUsuario,'','','','','','','','','','','','',elemento2[0].tarea,'','','','','',0,parseFloat(elemento2[0].mensual).toFixed(1),parseFloat(elemento2[0].anual).toFixed(1),0,0)
        //   reportes.push(argsLinea)
        // })


        // ***** HORAS HOMBRE POR I / O POR MES Y AÑO ***************************

        argsBuscarPl = {tipoqry: `[
          {"$unwind": "$secciones"},
          {"$unwind": "$secciones.equipos"},
          {"$unwind": "$secciones.equipos.componentes"},
          {"$unwind": "$secciones.equipos.componentes.mecanismos"},
          {"$unwind": "$secciones.equipos.componentes.mecanismos.programacion"},
          {$match: {'secciones.equipos.componentes.mecanismos.programacion.minutos': {$ne: ""},
                    'secciones.equipos.componentes.mecanismos.programacion.modoTarea': {$ne: ""}}},
          {$project: {_id: 1,
            descrEmpresa: 1, codPlanta: 1, descrPlanta: 1,
            codSeccion: '$secciones.codSeccion', descrSeccion: '$secciones.descrSeccion',
            codEquipo: '$secciones.equipos.codEquipo', descrEquipo: '$secciones.equipos.descrEquipo',
            codComponente: '$secciones.equipos.componentes.codComponente',
            descrComponente: '$secciones.equipos.componentes.descrComponente',
            descrMecanismo: '$secciones.equipos.componentes.mecanismos.descrMecanismo',
            modoTarea: '$secciones.equipos.componentes.mecanismos.programacion.modoTarea',
            descrFrecuencia: '$secciones.equipos.componentes.mecanismos.programacion.descrFrecuencia',
            descrFrecuenciaPre: '$secciones.equipos.componentes.mecanismos.programacion.descrFrecuenciaPre',
            minutos: '$secciones.equipos.componentes.mecanismos.programacion.minutos'
          }}, {$match: {${argsBuscar}}}, 
          {$group: {_id: {modoTarea: '$modoTarea', descrFrecuencia: '$descrFrecuencia', 
                    descrFrecuenciaPre: '$descrFrecuenciaPre'},
                    totalCantidad: {$sum: {$toDouble: '$minutos'}}}},
          {$project: {modoTarea: '$_id.modoTarea', 
          descrFrecuencia: '$_id.descrFrecuencia', descrFrecuenciaPre: '$_id.descrFrecuenciaPre',
          ultInforme: {$toDouble: '$totalCantidad'}}},
            {$sort: {modoTarea: 1}}]`}

        if(2>1){
          let {data} = await this.props.allPlantaRtes3.refetch(argsBuscarPl)
          let estructura1 = await data.allPlantaRtes
          // console.log(estructura1)
          let indexTa = -1
          for(let ii=0; ii<estructura1.length; ii++){
            if(estructura1[ii].modoTarea==='I'){
              indexTa = 0
            }
            if(estructura1[ii].modoTarea==='O'){
              indexTa = 1
            }
            let cantidadHoras=0

            if(indexTa!==-1 && estructura1[ii].ultInforme>0){
              cantidadHoras=estructura1[ii].ultInforme/60
              let cantidadMes=0
              let cantidadAnual=0
              let indexFrec = -1
              if(estructura1[ii].descrFrecuencia==='Predictiva'){
                indexFrec = allFrecuencia.findIndex( frecuencia => frecuencia.descrFrecuencia===estructura1[ii].descrFrecuenciaPre )
              }else{
                indexFrec = allFrecuencia.findIndex( frecuencia => frecuencia.descrFrecuencia===estructura1[ii].descrFrecuencia )
              }
              if(indexFrec!==-1){
                if(allFrecuencia[indexFrec].tipoFrecuencia!=='Km'){
                  if(allFrecuencia[indexFrec].tipoFrecuencia==='Calendario'){
                    cantidadMes=(cantidadHoras*30)/allFrecuencia[indexFrec].cantidad
                    cantidadAnual=(cantidadHoras*360)/allFrecuencia[indexFrec].cantidad
                  }else{
                    cantidadMes=(cantidadHoras*720)/allFrecuencia[indexFrec].cantidad
                    cantidadAnual=(cantidadHoras*8640)/allFrecuencia[indexFrec].cantidad
                  }
                }
              }
              modo[indexTa][0].mensual=modo[indexTa][0].mensual + cantidadMes
              modo[indexTa][0].anual=modo[indexTa][0].anual + cantidadAnual
              // console.log(modo)
            }
            modo[indexTa][0].mensual=parseFloat(modo[indexTa][0].mensual).toFixed(1)
            modo[indexTa][0].anual=parseFloat(modo[indexTa][0].anual).toFixed(1)
          }
        }

        // modo.forEach((elemento2, ii) => {
        //   argsLinea=this.crearLinea('ANEXOS','HORAS-HOMBRE POR MODO DE TAREA',nombreUsuario,'','','','','','','','','','','','','','','','',elemento2[0].modo,'',0,parseFloat(elemento2[0].mensual).toFixed(1),parseFloat(elemento2[0].anual).toFixed(1),0,0)
        //   reportes.push(argsLinea)
        // })

        // ***** HORAS HOMBRE POR SISO POR MES Y AÑO ***************************

        argsBuscarPl = {tipoqry: `[
          {"$unwind": "$secciones"},
          {"$unwind": "$secciones.equipos"},
          {"$unwind": "$secciones.equipos.componentes"},
          {"$unwind": "$secciones.equipos.componentes.mecanismos"},
          {"$unwind": "$secciones.equipos.componentes.mecanismos.programacion"},
          {$match: {'secciones.equipos.componentes.mecanismos.programacion.minutos': {$ne: ""},
                    'secciones.equipos.componentes.mecanismos.programacion.requiereSISO': {$ne: ""}}},
          {$project: {_id: 1,
            descrEmpresa: 1, codPlanta: 1, descrPlanta: 1,
            codSeccion: '$secciones.codSeccion', descrSeccion: '$secciones.descrSeccion',
            codEquipo: '$secciones.equipos.codEquipo', descrEquipo: '$secciones.equipos.descrEquipo',
            codComponente: '$secciones.equipos.componentes.codComponente',
            descrComponente: '$secciones.equipos.componentes.descrComponente',
            descrMecanismo: '$secciones.equipos.componentes.mecanismos.descrMecanismo',
            requiereSISO: '$secciones.equipos.componentes.mecanismos.programacion.requiereSISO',
            descrFrecuencia: '$secciones.equipos.componentes.mecanismos.programacion.descrFrecuencia',
            descrFrecuenciaPre: '$secciones.equipos.componentes.mecanismos.programacion.descrFrecuenciaPre',
            minutos: '$secciones.equipos.componentes.mecanismos.programacion.minutos'
          }}, {$match: {${argsBuscar}}}, 
          {$group: {_id: {requiereSISO: '$requiereSISO', descrFrecuencia: '$descrFrecuencia', 
                    descrFrecuenciaPre: '$descrFrecuenciaPre'},
                    totalCantidad: {$sum: {$toDouble: '$minutos'}}}},
          {$project: {requiereSISO: '$_id.requiereSISO', 
          descrFrecuencia: '$_id.descrFrecuencia', descrFrecuenciaPre: '$_id.descrFrecuenciaPre',
          ultInforme: {$toDouble: '$totalCantidad'}}},
            {$sort: {requiereSISO: 1}}]`}

        if(2>1){
          let {data} = await this.props.allPlantaRtes3.refetch(argsBuscarPl)
          let estructura1 = await data.allPlantaRtes
          // console.log(estructura1)
          let indexTa = -1
          for(let ii=0; ii<estructura1.length; ii++){
            if(estructura1[ii].requiereSISO==='Si'){
              indexTa = 0
            }
            if(estructura1[ii].requiereSISO==='No'){
              indexTa = 1
            }
            let cantidadHoras=0

            if(indexTa!==-1 && estructura1[ii].ultInforme>0){
              cantidadHoras=estructura1[ii].ultInforme/60
              let cantidadMes=0
              let cantidadAnual=0
              let indexFrec = -1
              if(estructura1[ii].descrFrecuencia==='Predictiva'){
                indexFrec = allFrecuencia.findIndex( frecuencia => frecuencia.descrFrecuencia===estructura1[ii].descrFrecuenciaPre )
              }else{
                indexFrec = allFrecuencia.findIndex( frecuencia => frecuencia.descrFrecuencia===estructura1[ii].descrFrecuencia )
              }
              if(indexFrec!==-1){
                if(allFrecuencia[indexFrec].tipoFrecuencia!=='Km'){
                  if(allFrecuencia[indexFrec].tipoFrecuencia==='Calendario'){
                    cantidadMes=(cantidadHoras*30)/allFrecuencia[indexFrec].cantidad
                    cantidadAnual=(cantidadHoras*360)/allFrecuencia[indexFrec].cantidad
                  }else{
                    cantidadMes=(cantidadHoras*720)/allFrecuencia[indexFrec].cantidad
                    cantidadAnual=(cantidadHoras*8640)/allFrecuencia[indexFrec].cantidad
                  }
                }
              }
              siso[indexTa][0].mensual=siso[indexTa][0].mensual + cantidadMes
              siso[indexTa][0].anual=siso[indexTa][0].anual + cantidadAnual
              siso[indexTa][0].mensual=parseFloat(siso[indexTa][0].mensual).toFixed(1)
              siso[indexTa][0].anual=parseFloat(siso[indexTa][0].anual).toFixed(1)
            }
          }
        }

// *************** GENERAR PDF DE ANEXOS *********************************************

        
        let doc = new jsPDF({orientation: 'p', unit: 'mm', format: 'letter'})
        let widthDoc = (doc.internal.pageSize.width)
        let heightDoc = (doc.internal.pageSize.height)


        // INICIA CONSUMO DE LUBRICANTES
       
        doc.setFillColor('#E9E4F0');
        doc.lines([[(widthDoc/2)-12,0],[0,5],[0-(widthDoc/2)+12,0]], 12,36, [1,1], 'F', true)
        doc.lines([[(widthDoc/2)-12,0],[0,5],[0-(widthDoc/2)+12,0]], (widthDoc/2),36, [1,1], 'F', true)
        doc.lines([[(widthDoc)-24,0],[0,5],[0-(widthDoc)+24,0]], 12,41, [1,1], 'F', true)
        doc.setFillColor('#bdc3c7');

        doc.setDrawColor('black');
        doc.lines([[(widthDoc/2)-12,0],[0,5],[0-(widthDoc/2)+12,0]], 12,36, [1,1], 'S', true)
        doc.lines([[(widthDoc/2)-12,0],[0,5],[0-(widthDoc/2)+12,0]], (widthDoc/2),36, [1,1], 'S', true)
        doc.lines([[(widthDoc)-24,0],[0,5],[0-(widthDoc)+24,0]], 12,41, [1,1], 'S', true)

        doc.setFontSize(8);
        doc.setFontStyle('bold');
        doc.text(`${list[0].descrEmpresa}`,14, 40)
        doc.text(`ANEXOS A CARTAS DE LUBRICACION`, (widthDoc/2)+2, 40)
        doc.text(`ANEXO 1:  CONSUMO DE LUBRICANTES`, (widthDoc/2), 45, 'center')

        let tablaRte = []
        lubricantes.forEach((elemento1, iii) => {
          let argsUpd = []

          argsUpd.push(iii+1)
          argsUpd.push(elemento1[0].tipo)
          argsUpd.push(elemento1[0].lubricante)
          argsUpd.push(elemento1[0].unidad)
          argsUpd.push(new Intl.NumberFormat('de-DE').format(elemento1[0].total))
          argsUpd.push(new Intl.NumberFormat('de-DE').format(elemento1[0].mensual))
          argsUpd.push(new Intl.NumberFormat('de-DE').format(elemento1[0].anual))
          tablaRte.push(argsUpd) 
        })

        doc.autoTable({
          startY: 46,
          rowPageBreak: 'avoid',  //cambia de página si la ultima fila queda incompleta
          showHead: 'everyPage',
          tableLineColor: "black",
          tableLineWidth: 0.1,
          styles: {
            fontSize: 8,
            lineColor: "black",
            lineWidth: 0.1,
            // valign: "top",
          },
          headStyles: {
            fillColor: "#E9E4F0",
            textColor: "black",
            halign: "center",
            // valign: "top",
            cellPadding: 1,
            fontStyle: "bold",
            fontSize: 8
          },
          bodyStyles: {
            // fillColor: "#E9E4F0",
            fillColor: "white",
            textColor: "black",
            halign: "center",
            // valign: "center",
            minCellHeight: 5
          },
          columnStyles: {
            0: {cellWidth: 20},
            1: {cellWidth: 20},
            2: {cellWidth: 69.4},
            3: {cellWidth: 20},
            4: {cellWidth: 20},
            5: {cellWidth: 20},
            6: {cellWidth: 20},
          },

          alternateRowStyles: {
            // fillColor: "white",
            textColor: "black"
          },
          head: [["No,", "Tipo", "Lubricante", "Unidad", "Volumen total", "Consumo mensual", "Consumo anual"]],
          body: tablaRte,
          margin: {top: 40, left: 12, right: 12, bottom: 25}
        })
        doc.addPage()

            //FIN PDF CONSUMO DE LUBRICANTES

// INICIA ANEXO 2 PROTECTORES Y GRASERAS

        doc.setFillColor('#E9E4F0');
        doc.lines([[(widthDoc)-24,0],[0,5],[0-(widthDoc)+24,0]], 12,41, [1,1], 'F', true)
        doc.setFillColor('#bdc3c7');

        doc.setDrawColor('black');
        doc.lines([[(widthDoc)-24,0],[0,5],[0-(widthDoc)+24,0]], 12,41, [1,1], 'S', true)

        doc.setFontSize(8);
        doc.setFontStyle('bold');
        doc.text(`ANEXO 2:  PROTECTORES Y PISTOLAS ENGRASADORAS`, (widthDoc/2), 45, 'center')

        tablaRte = []
        protectores.forEach((elemento1, iii) => {
          let argsUpd = []
          argsUpd.push(iii+1)
          argsUpd.push("")
          argsUpd.push(elemento1[0].espesante)
          argsUpd.push(elemento1[0].puntos)
          argsUpd.push(elemento1[0].graseras)
          tablaRte.push(argsUpd) 
        })
        doc.autoTable({
          startY: 46,
          rowPageBreak: 'avoid',  //cambia de página si la ultima fila queda incompleta
          showHead: 'everyPage',
          tableLineColor: "black",
          tableLineWidth: 0.1,
          styles: {
            fontSize: 8,
            lineColor: "black",
            lineWidth: 0.1,
            // valign: "top",
          },
          headStyles: {
            fillColor: "#E9E4F0",
            textColor: "black",
            halign: "center",
            // valign: "top",
            cellPadding: 1,
            fontStyle: "bold",
            fontSize: 8
          },
          bodyStyles: {
            // fillColor: "#E9E4F0",
            fillColor: "white",
            textColor: "black",
            halign: "center",
            // valign: "center",
            minCellHeight: 5
          },
          columnStyles: {
            0: {cellWidth: 20},
            1: {cellWidth: 20},
            2: {cellWidth: 110},
            3: {cellWidth: 20},
            4: {cellWidth: 20},
          },

          didParseCell(data) {
            if(data.row.index !== -1 && data.section==='body' && data.column.index === 1){
              data.cell.styles.fillColor = protectores[data.row.index][0].color
            }
          },
          alternateRowStyles: {
            // fillColor: "white",
            textColor: "black"
          },
          head: [["No,", "Color", "Espesante", "Protectores", "Pistola engrasadora"]],
          body: tablaRte,
          margin: {top: 40, left: 12, right: 12, bottom: 25}
        })
        doc.addPage()


        //FIN PDF CONSUMO DE PROTECTORES Y GRASERAS

        // INICIA ANEXO 3 ACEITERAS

        doc.setFillColor('#E9E4F0');
        doc.lines([[(widthDoc)-24,0],[0,5],[0-(widthDoc)+24,0]], 12,41, [1,1], 'F', true)
        doc.setFillColor('#bdc3c7');

        doc.setDrawColor('black');
        doc.lines([[(widthDoc)-24,0],[0,5],[0-(widthDoc)+24,0]], 12,41, [1,1], 'S', true)

        doc.setFontSize(8);
        doc.setFontStyle('bold');
        doc.text(`ANEXO 3:  ACEITERAS`, (widthDoc/2), 45, 'center')

        tablaRte = []
        aceiteras.forEach((elemento1, iii) => {
          let argsUpd = []
          argsUpd.push(iii+1)
          argsUpd.push("")
          argsUpd.push(elemento1[0].aplicacion)
          argsUpd.push(elemento1[0].puntos)
          argsUpd.push(elemento1[0].aceiteras)
          tablaRte.push(argsUpd) 
        })
        doc.autoTable({
          startY: 46,
          rowPageBreak: 'avoid',  //cambia de página si la ultima fila queda incompleta
          showHead: 'everyPage',
          tableLineColor: "black",
          tableLineWidth: 0.1,
          styles: {
            fontSize: 8,
            lineColor: "black",
            lineWidth: 0.1,
            // valign: "top",
          },
          headStyles: {
            fillColor: "#E9E4F0",
            textColor: "black",
            halign: "center",
            // valign: "top",
            cellPadding: 1,
            fontStyle: "bold",
            fontSize: 8
          },
          bodyStyles: {
            // fillColor: "#E9E4F0",
            fillColor: "white",
            textColor: "black",
            halign: "center",
            // valign: "center",
            minCellHeight: 5
          },
          columnStyles: {
            0: {cellWidth: 20},
            1: {cellWidth: 20},
            2: {cellWidth: 110},
            3: {cellWidth: 20},
            4: {cellWidth: 20},
          },

          didParseCell(data) {
            if(data.row.index !== -1 && data.section==='body' && data.column.index === 1){
              data.cell.styles.fillColor = aceiteras[data.row.index][0].color
            }
          },
          alternateRowStyles: {
            // fillColor: "white",
            textColor: "black"
          },
          head: [["No,", "Color", "Aplicación", "Puntos", "Aceiteras"]],
          body: tablaRte,
          margin: {top: 40, left: 12, right: 12, bottom: 25}
        })
        doc.addPage()


        //FIN PDF CONSUMO DE PROTECTORES Y GRASERAS

        // INICIA ANEXO 4 TAREAS

        doc.setFillColor('#E9E4F0');
        doc.lines([[(widthDoc)-24,0],[0,5],[0-(widthDoc)+24,0]], 12,41, [1,1], 'F', true)
        doc.setFillColor('#bdc3c7');

        doc.setDrawColor('black');
        doc.lines([[(widthDoc)-24,0],[0,5],[0-(widthDoc)+24,0]], 12,41, [1,1], 'S', true)

        doc.setFontSize(8);
        doc.setFontStyle('bold');
        doc.text(`ANEXO 4:  HORAS-HOMBRE POR TAREA`, (widthDoc/2), 45, 'center')

        tablaRte = []
        let posic=52
        console.log(tareas)
        tareas.forEach((elemento1, iii) => {
          let argsUpd = []
          argsUpd.push(iii+1)
          argsUpd.push(elemento1[0].tarea)
          // argsUpd.push(elemento1[0].total)
          argsUpd.push(new Intl.NumberFormat('de-DE').format(elemento1[0].mensual))
          argsUpd.push(new Intl.NumberFormat('de-DE').format(elemento1[0].anual))
          tablaRte.push(argsUpd) 
          posic+=6
        })
        doc.autoTable({
          startY: 46,
          rowPageBreak: 'avoid',  //cambia de página si la ultima fila queda incompleta
          showHead: 'everyPage',
          tableLineColor: "black",
          tableLineWidth: 0.1,
          styles: {
            fontSize: 8,
            lineColor: "black",
            lineWidth: 0.1,
            // valign: "top",
          },
          headStyles: {
            fillColor: "#E9E4F0",
            textColor: "black",
            halign: "center",
            // valign: "top",
            cellPadding: 1,
            fontStyle: "bold",
            fontSize: 8
          },
          bodyStyles: {
            // fillColor: "#E9E4F0",
            fillColor: "white",
            textColor: "black",
            halign: "center",
            // valign: "center",
            minCellHeight: 5
          },
          columnStyles: {
            0: {cellWidth: 20},
            1: {cellWidth: 130.3},
            2: {cellWidth: 20},
            3: {cellWidth: 20},
            // 4: {cellWidth: 20},
          },

          alternateRowStyles: {
            textColor: "black"
          },
          head: [["No,", "Tarea", "Mensual", "Anual"]],
          body: tablaRte,
          margin: {top: 40, left: 12, right: 12, bottom: 25}
        })

        //FIN PDF HORAS HOMBRE POR TAREA

        // INICIA ANEXO 5 HORAS HOMBRE I / O

        posic+=20
        doc.setFillColor('#E9E4F0');
        doc.lines([[(widthDoc)-24,0],[0,5],[0-(widthDoc)+24,0]], 12,posic, [1,1], 'F', true)
        doc.setFillColor('#bdc3c7');

        doc.setDrawColor('black');
        doc.lines([[(widthDoc)-24,0],[0,5],[0-(widthDoc)+24,0]], 12,posic, [1,1], 'S', true)

        doc.setFontSize(8);
        doc.setFontStyle('bold');
        doc.text(`ANEXO 5:  HORAS-HOMBRE POR MODO DE TAREA`, (widthDoc/2), posic + 4, 'center')

        tablaRte = []
        posic+=5
        console.log(modo)

        modo.forEach((elemento1, iii) => {
          let argsUpd = []
          argsUpd.push(iii+1)
          argsUpd.push(elemento1[0].modo)
          // argsUpd.push(elemento1[0].total)
          argsUpd.push(new Intl.NumberFormat('de-DE').format(elemento1[0].mensual))
          argsUpd.push(new Intl.NumberFormat('de-DE').format(elemento1[0].anual))
          tablaRte.push(argsUpd) 
        })
        doc.autoTable({
          startY: posic,
          rowPageBreak: 'avoid',  //cambia de página si la ultima fila queda incompleta
          showHead: 'everyPage',
          tableLineColor: "black",
          tableLineWidth: 0.1,
          styles: {
            fontSize: 8,
            lineColor: "black",
            lineWidth: 0.1,
            // valign: "top",
          },
          headStyles: {
            fillColor: "#E9E4F0",
            textColor: "black",
            halign: "center",
            // valign: "top",
            cellPadding: 1,
            fontStyle: "bold",
            fontSize: 8
          },
          bodyStyles: {
            // fillColor: "#E9E4F0",
            fillColor: "white",
            textColor: "black",
            halign: "center",
            // valign: "center",
            minCellHeight: 5
          },
          columnStyles: {
            0: {cellWidth: 20},
            1: {cellWidth: 130.3},
            2: {cellWidth: 20},
            3: {cellWidth: 20},
            // 4: {cellWidth: 20},
          },

          alternateRowStyles: {
            textColor: "black"
          },
          head: [["No,", "Modo de ejecución tarea", "Mensual", "Anual"]],
          body: tablaRte,
          margin: {top: 40, left: 12, right: 12, bottom: 25}
        })

        //FIN PDF HORAS HOMBRE POR TAREA

        // INICIA ANEXO 5 HORAS HOMBRE SISO

        posic+=30
        doc.setFillColor('#E9E4F0');
        doc.lines([[(widthDoc)-24,0],[0,5],[0-(widthDoc)+24,0]], 12,posic, [1,1], 'F', true)
        doc.setFillColor('#bdc3c7');

        doc.setDrawColor('black');
        doc.lines([[(widthDoc)-24,0],[0,5],[0-(widthDoc)+24,0]], 12,posic, [1,1], 'S', true)

        doc.setFontSize(8);
        doc.setFontStyle('bold');
        doc.text(`ANEXO 6:  HORAS-HOMBRE POR TIPO DE RIESGO`, (widthDoc/2), posic + 4, 'center')

        tablaRte = []
        posic+=5
        console.log(siso)

        siso.forEach((elemento1, iii) => {
          let argsUpd = []
          argsUpd.push(iii+1)
          argsUpd.push(elemento1[0].siso)
          // argsUpd.push(elemento1[0].total)
          argsUpd.push(new Intl.NumberFormat('de-DE').format(elemento1[0].mensual))
          argsUpd.push(new Intl.NumberFormat('de-DE').format(elemento1[0].anual))
          tablaRte.push(argsUpd) 
        })
        doc.autoTable({
          startY: posic,
          rowPageBreak: 'avoid',  //cambia de página si la ultima fila queda incompleta
          showHead: 'everyPage',
          tableLineColor: "black",
          tableLineWidth: 0.1,
          styles: {
            fontSize: 8,
            lineColor: "black",
            lineWidth: 0.1,
            // valign: "top",
          },
          headStyles: {
            fillColor: "#E9E4F0",
            textColor: "black",
            halign: "center",
            // valign: "top",
            cellPadding: 1,
            fontStyle: "bold",
            fontSize: 8
          },
          bodyStyles: {
            // fillColor: "#E9E4F0",
            fillColor: "white",
            textColor: "black",
            halign: "center",
            // valign: "center",
            minCellHeight: 5
          },
          columnStyles: {
            0: {cellWidth: 20},
            1: {cellWidth: 130.3},
            2: {cellWidth: 20},
            3: {cellWidth: 20},
            // 4: {cellWidth: 20},
          },

          alternateRowStyles: {
            textColor: "black"
          },
          head: [["No,", "Tipo de riesgo", "Mensual", "Anual"]],
          body: tablaRte,
          margin: {top: 40, left: 12, right: 12, bottom: 25}
        })

          const pageCount = doc.internal.getNumberOfPages();
          // For each page, print the page number and the total pages
          for(var i = 1; i <= pageCount; i++) {
                // Go to page i
              doc.setPage(i);

        //ENCABEZADO DE PAGINA
              // doc.setFontSize(12);
              // doc.setFontType("bold");
              // doc.text(list1[0].descrEmpresa, widthDoc/2, 14, 'center')
              // doc.text("ANEXOS A CARTAS DE LUBRICACION", widthDoc/2, 20, 'center')
              // doc.setFontSize(8);

              let dirSlcm = 'images/logos/LCMSAS.png'
              let logo = ""
              if(this.props.allEmpresaRtes.allEmpresaRtes){

                let argsBuscarEmp = {tipoqry: `[{$match: {'descrEmpresa': '${list[0].descrEmpresa}'}}]`}
                console.log(argsBuscarEmp)
                let {data} = await this.props.allEmpresaRtes.refetch(argsBuscarEmp)
                console.log(data.allEmpresaRtes)
                logo = await data.allEmpresaRtes[0].logo
                console.log(logo)
              }
              let dirEmpresa = 'images/logos/' + logo
              let imgSource = new Image();
              try{
                imgSource.src = dirSlcm;
                doc.convertStringToImageData(imgSource)
                doc.addImage(imgSource, 'PNG', 12, 12, 45, 17);
              }catch{
                console.log("Logo de LCM no existe")
              }

              try{
                imgSource.src = dirEmpresa;
                doc.convertStringToImageData(imgSource)
                doc.addImage(imgSource, 'PNG', widthDoc-65-12, 12, 45, 17);
              }catch{
                console.log("Logo de la empresa no existe")
              }
        //FIN ENCABEZADO DE PAGINA

              doc.text('Pag ' + String(i) + ' de ' + String(pageCount), 12, heightDoc-12, 'left')
              doc.text(fechaHoraHoy.substr(0, 10) + " " + fechaHoraHoy.substr(11, 5), widthDoc-50, heightDoc-12, 'left')
              // doc.text('Pag ' + String(i) + ' de ' + String(pageCount),210-20,297-30,null,null,"left");
          }
        let nameDoc = `ANEXOS_${list[0].descrEmpresa}.pdf`
        doc.save(nameDoc)






        document.body.style.cursor = 'default' 
      }else{
        alert(`La empresa ${args.descrEmpresa} no tiene información de Cartas de Lubricación`)
      }
    }
    this.setState({permiteBtn1: true, open: false, confirmaAct: false})
  }


  handleSubmit = async (ev, list, list2, args)=>{
    // document.body.style.cursor = 'wait'
    var QRCode = require('qrcode');
    if(list.length>0){
      console.log(list, list2, args)

      await cartaLub2(
        list,
        list2,
        args,
        'N',
        {
          allPlantaRtes2: this.props.allPlantaRtesC, 
          productos: this.props.allProducto, 
          fecha: this.props.fecha
        }
      );


      if (1>2){
        let estructuraMec = []
        let argsBuscar=""
        argsBuscar += `'descrEmpresa': '${args.descrEmpresa}'`

        let argsBuscarMec = {tipoqry: `[
          {"$unwind": "$secciones"},
          {"$unwind": "$secciones.equipos"},
          {"$unwind": "$secciones.equipos.componentes"},
          {"$unwind": "$secciones.equipos.componentes.mecanismos"},
          {$project: {_id: 1,
            descrEmpresa: 1, descrPlanta: 1, descrSeccion: '$secciones.descrSeccion',
            descrEquipo: '$secciones.equipos.descrEquipo', descrComponente: '$secciones.equipos.componentes.descrComponente',
            descrMecanismo: '$secciones.equipos.componentes.mecanismos.descrMecanismo'}},
          {$group: {_id: {descrEmpresa: '$descrEmpresa', descrPlanta: '$descrPlanta',descrSeccion: '$descrSeccion',
              descrEquipo: '$descrEquipo', descrComponente: '$descrComponente'}, count: { $sum: 1 }}},
          {$project: {_id: 0, descrEmpresa: "$_id.descrEmpresa", descrPlanta: '$_id.descrPlanta', 
            descrSeccion: '$_id.descrSeccion', descrEquipo: '$_id.descrEquipo', 
            descrComponente: '$_id.descrComponente', ultInforme: {$toInt: '$count'}}},
            {$match: {${argsBuscar}}}, {$sort: {descrPlanta: 1, descrSeccion: 1, descrEquipo: 1, descrComponente: 1}}]`}

        if(2>1){
          let {data} = await this.props.allPlantaRtes2.refetch(argsBuscarMec)
          estructuraMec = await data.allPlantaRtes
        }


        argsBuscar=""
        // argsBuscar += `'descrEmpresa': '${args.descrEmpresa}'`
        argsBuscar += `'descrEmpresa': '${args.descrEmpresa}', 'descrSeccion': {$ne: 'Linea Placa Yeso'}`
        // argsBuscar += `'descrEmpresa': '${args.descrEmpresa}', 'descrSeccion': {$ne: 'SECADOR'}`

        if(args.descrPlanta){
          argsBuscar += `, 'descrPlanta': /${args.descrPlanta}/i`
        }
        if(args.descrSeccion){
          argsBuscar += `, 'descrSeccion': /${args.descrSeccion}/i`
        }
        if(args.descrEquipo){
          argsBuscar += `, 'descrEquipo': /${args.descrEquipo}/i`
        }
        if(args.descrComponente){
          argsBuscar += `, 'descrComponente': /${args.descrComponente}/i`
        } 

        let argsBuscarPl = {tipoqry: `[
          {"$unwind": "$secciones"},
          {"$unwind": "$secciones.equipos"},
          {"$unwind": "$secciones.equipos.componentes"},
          {"$unwind": "$secciones.equipos.componentes.mecanismos"},
          {"$unwind": "$secciones.equipos.componentes.mecanismos.programacion"},
          {$match: {'secciones.equipos.componentes.mecanismos.programacion.puntosLub': {$ne: ""}}},
          {$project: {_id: 1,
            descrEmpresa: 1, codPlanta: 1, descrPlanta: 1,
            codSeccion: '$secciones.codSeccion', descrSeccion: '$secciones.descrSeccion',
            codEquipo: '$secciones.equipos.codEquipo', descrEquipo: '$secciones.equipos.descrEquipo',
            numCarta: '$secciones.equipos.numCarta',
            codComponente: '$secciones.equipos.componentes.codComponente',
            descrComponente: '$secciones.equipos.componentes.descrComponente',
            descrMecanismo: '$secciones.equipos.componentes.mecanismos.descrMecanismo',
            consecutivo:{$cond: { 
              if: { $gt: [ '$secciones.equipos.componentes.mecanismos.programacion.consecutivo', '' ] },
                then: {$toInt: '$secciones.equipos.componentes.mecanismos.programacion.consecutivo'}, else: {$toInt: 0}
              }
            },         
            puntosLub: {$toInt: '$secciones.equipos.componentes.mecanismos.programacion.puntosLub'}}},
          {$group: {_id: {descrEmpresa: '$descrEmpresa', descrPlanta: '$descrPlanta', numCarta: '$numCarta', descrSeccion: '$descrSeccion',
              descrEquipo: '$descrEquipo', descrComponente: '$descrComponente', codPlanta: '$codPlanta',
              codSeccion: '$codSeccion', codEquipo: '$codEquipo', codComponente: '$codComponente'},
            cantidadTotal: {$sum: '$puntosLub'}, count: { $sum: 1 }, minutos: {$min: '$consecutivo'}}},
          {$project: {_id: 0, descrEmpresa: "$_id.descrEmpresa",
            codPlanta: '$_id.codPlanta', descrPlanta: '$_id.descrPlanta', numCarta: '$_id.numCarta',
            codSeccion: '$_id.codSeccion', descrSeccion: '$_id.descrSeccion',
            codEquipo: '$_id.codEquipo', descrEquipo: '$_id.descrEquipo',
            codComponente: '$_id.codComponente', descrComponente: '$_id.descrComponente', 
            cantidadTotal: 1, acumUlt: {$toInt: '$count'}, minutos: 1}},
            {$match: {${argsBuscar}}}, {$sort: {descrPlanta: 1, numCarta: 1, minutos: 1}}]`}

        let {data} = await this.props.allPlantaRtes2.refetch(argsBuscarPl)
        let estructura = await data.allPlantaRtes
        console.log(estructura)
        let allProducto = this.props.allProducto.allProducto
        console.log(allProducto)
        document.body.style.cursor = 'default'
        if(estructura.length>0){       
          document.body.style.cursor = 'wait' 
          let response = await this.props.fecha({
            variables: {}
          });
          const {fechaHoraHoy} = response.data.fecha

          let rutaArch = '/home//slcm//slcm-client//public//images//procedimientos//'   //Servidor

          let doc = new jsPDF({orientation: 'l', unit: 'mm', format: 'letter'})
          // let widthDoc = (doc.internal.pageSize.width)
          let widthDoc = 267.4
          let heightDoc = (doc.internal.pageSize.height)

          doc.setFontSize(10);
          doc.setFontStyle('bold');

          //TABLA DE CONTENIDO
          let tablaRte = [], tablaRte1 = []
          let documento = {}
          let empresa = ""
          let planta = ""
          let seccion = ""
          let equipo = ""
          let totPuntosE = await estructura.filter(elemento => elemento.descrEmpresa===args.descrEmpresa)
          let totPtosEmp = _(totPuntosE)
            .groupBy('descrEmpresa')
            .map((obj, key) => ({
              'descrEmpresa': key,
              'cantidadTotal':_.sumBy(obj, 'cantidadTotal'),
              'acumUlt':_.sumBy(obj, 'acumUlt')
            }))
            .value()
            let totMecE = await estructuraMec.filter(elemento => elemento.descrEmpresa===args.descrEmpresa)
            let totMecEmp = _(totMecE)
              .groupBy('descrEmpresa')
              .map((obj, key) => ({
                'descrEmpresa': key,
                'ultInforme':_.sumBy(obj, 'ultInforme')
              }))
              .value()
          for(let ii=0; ii<estructura.length; ii++){
            if(ii===0){
              let totPuntos = await estructura.filter(elemento => elemento.descrPlanta===estructura[ii].descrPlanta)
              let totPtosPl = _(totPuntos)
                .groupBy('descrPlanta')
                .map((obj, key) => ({
                  'descrPlanta': key,
                  'cantidadTotal':_.sumBy(obj, 'cantidadTotal'),
                  'acumUlt':_.sumBy(obj, 'acumUlt')
                }))
                .value()
              let totMecP = await estructuraMec.filter(elemento => elemento.descrPlanta===estructura[ii].descrPlanta)
              let totMecPl = _(totMecP)
                .groupBy('descrPlanta')
                .map((obj, key) => ({
                  'descrPlanta': key,
                  'ultInforme':_.sumBy(obj, 'ultInforme')
                }))
                .value()

              totPuntos = await estructura.filter(elemento => elemento.descrPlanta===estructura[ii].descrPlanta&&
                elemento.descrSeccion===estructura[ii].descrSeccion)
              let totPtosSe = _(totPuntos)
                .groupBy('descrSeccion')
                .map((obj, key) => ({
                  'descrSeccion': key,
                  'cantidadTotal':_.sumBy(obj, 'cantidadTotal'),
                  'acumUlt':_.sumBy(obj, 'acumUlt')
                }))
                .value()
                let totMecS = await estructuraMec.filter(elemento => elemento.descrPlanta===estructura[ii].descrPlanta&&
                  elemento.descrSeccion===estructura[ii].descrSeccion)
                let totMecSe = _(totMecS)
                  .groupBy('descrSeccion')
                  .map((obj, key) => ({
                    'descrSeccion': key,
                    'ultInforme':_.sumBy(obj, 'ultInforme')
                  }))
                  .value()

              totPuntos = await estructura.filter(elemento => elemento.descrPlanta===estructura[ii].descrPlanta&&
                elemento.descrSeccion===estructura[ii].descrSeccion&&elemento.descrEquipo===estructura[ii].descrEquipo)
              let totPtosEq = _(totPuntos)
                .groupBy('descrEquipo')
                .map((obj, key) => ({
                  'descrEquipo': key,
                  'cantidadTotal':_.sumBy(obj, 'cantidadTotal'),
                  'acumUlt':_.sumBy(obj, 'acumUlt')
                }))
                .value()
              let totMecE = await estructuraMec.filter(elemento => elemento.descrPlanta===estructura[ii].descrPlanta&&
                elemento.descrSeccion===estructura[ii].descrSeccion&&elemento.descrEquipo===estructura[ii].descrEquipo)
              let totMecEq = _(totMecE)
                .groupBy('descrEquipo')
                .map((obj, key) => ({
                  'descrEquipo': key,
                  'ultInforme':_.sumBy(obj, 'ultInforme')
                }))
                .value()

              empresa = estructura[ii].descrEmpresa  
              planta = estructura[ii].descrPlanta
              seccion = estructura[ii].descrSeccion
              equipo = estructura[ii].descrEquipo
              documento = ({columna1: `EMPRESA: ${empresa}`, columna2: totMecEmp[0].ultInforme, columna3: totPtosEmp[0].acumUlt, columna4: totPtosEmp[0].cantidadTotal, columna5: ""})
              tablaRte1.push(documento)
              documento = ({columna1: `PLANTA: ${planta}`, columna2: totMecPl[0].ultInforme, columna3: totPtosPl[0].acumUlt, columna4: totPtosPl[0].cantidadTotal, columna5: ""})
              tablaRte1.push(documento)
              documento = ({columna1: `SECCION: ${seccion}`, columna2: totMecSe[0].ultInforme, columna3: totPtosSe[0].acumUlt, columna4: totPtosSe[0].cantidadTotal, columna5: ""})
              tablaRte1.push(documento)
              let numCarta = ""
              if(estructura[ii].numCarta){
                numCarta = estructura[ii].numCarta.toString()
              }
              documento = ({columna1: `EQUIPO: ${equipo}`, columna2: totMecEq[0].ultInforme, columna3: totPtosEq[0].acumUlt, columna4: totPtosEq[0].cantidadTotal, columna5: numCarta})
              tablaRte1.push(documento)
            }
            if(planta===estructura[ii].descrPlanta&&seccion===estructura[ii].descrSeccion&&equipo===estructura[ii].descrEquipo){
              let numCarta = ""
              if(estructura[ii].numCarta){
                numCarta = estructura[ii].numCarta.toString()
              }
              let totMecComp = await estructuraMec.filter(elemento => elemento.descrPlanta===estructura[ii].descrPlanta&&
                elemento.descrSeccion===estructura[ii].descrSeccion&&elemento.descrEquipo===estructura[ii].descrEquipo
                &&elemento.descrComponente===estructura[ii].descrComponente)
                // let totMecCo = totMecComp[0].ultInforme
              let totMecCo = _(totMecComp)
                .groupBy('descrComponente')
                .map((obj, key) => ({
                  'descrComponente': key,
                  'ultInforme':_.sumBy(obj, 'ultInforme')
                }))
                .value()
              documento = ({columna1: `COMPONENTE: ${estructura[ii].codComponente} ${estructura[ii].descrComponente}`, columna2: totMecCo[0].ultInforme, columna3: estructura[ii].acumUlt, columna4: estructura[ii].cantidadTotal, columna5: numCarta})
              tablaRte1.push(documento)
            }else{
              let totPuntos = await estructura.filter(elemento => elemento.descrPlanta===estructura[ii].descrPlanta)
              let totPtosPl = _(totPuntos)
                .groupBy('descrPlanta')
                .map((obj, key) => ({
                  'descrPlanta': key,
                  'cantidadTotal':_.sumBy(obj, 'cantidadTotal'),
                  'acumUlt':_.sumBy(obj, 'acumUlt')
                }))
                .value()
              let totMec = await estructuraMec.filter(elemento => elemento.descrPlanta===estructura[ii].descrPlanta)
              let totMecPl = _(totMec)
                .groupBy('descrPlanta')
                .map((obj, key) => ({
                  'descrPlanta': key,
                  'ultInforme':_.sumBy(obj, 'ultInforme')
                }))
                .value()

              totPuntos = await estructura.filter(elemento => elemento.descrPlanta===estructura[ii].descrPlanta&&
                elemento.descrSeccion===estructura[ii].descrSeccion)
              let totPtosSe = _(totPuntos)
                .groupBy('descrSeccion')
                .map((obj, key) => ({
                  'descrSeccion': key,
                  'cantidadTotal':_.sumBy(obj, 'cantidadTotal'),
                  'acumUlt':_.sumBy(obj, 'acumUlt')
                }))
                .value()
              totMec = await estructuraMec.filter(elemento => elemento.descrPlanta===estructura[ii].descrPlanta&&
                  elemento.descrSeccion===estructura[ii].descrSeccion)
              let totMecSe = _(totMec)
                .groupBy('descrSeccion')
                .map((obj, key) => ({
                  'descrSeccion': key,
                  'ultInforme':_.sumBy(obj, 'ultInforme')
                }))
                .value()  

              totPuntos = await estructura.filter(elemento => elemento.descrPlanta===estructura[ii].descrPlanta&&
                elemento.descrSeccion===estructura[ii].descrSeccion&&elemento.descrEquipo===estructura[ii].descrEquipo)
              let totPtosEq = _(totPuntos)
                .groupBy('descrEquipo')
                .map((obj, key) => ({
                  'descrEquipo': key,
                  'cantidadTotal':_.sumBy(obj, 'cantidadTotal'),
                  'acumUlt':_.sumBy(obj, 'acumUlt')
                }))
                .value()
              totMec = await estructuraMec.filter(elemento => elemento.descrPlanta===estructura[ii].descrPlanta&&
                elemento.descrSeccion===estructura[ii].descrSeccion&&elemento.descrEquipo===estructura[ii].descrEquipo)
              let totMecEq = _(totMec)
                .groupBy('descrEquipo')
                .map((obj, key) => ({
                  'descrEquipo': key,
                  'ultInforme':_.sumBy(obj, 'ultInforme')
                }))
                .value()  

              if(planta!==estructura[ii].descrPlanta){
                planta = estructura[ii].descrPlanta
                documento = ({columna1: `PLANTA: ${planta}`, columna2: totMecPl[0].ultInforme, columna3: totPtosPl[0].acumUlt, columna4: totPtosPl[0].cantidadTotal, columna5: ""})
                tablaRte1.push(documento)
              }
              if(seccion!==estructura[ii].descrSeccion){
                seccion = estructura[ii].descrSeccion
                documento = ({columna1: `SECCION: ${seccion}`, columna2: totMecSe[0].ultInforme, columna3: totPtosSe[0].acumUlt, columna4: totPtosSe[0].cantidadTotal, columna5: ""})
                tablaRte1.push(documento)
              }
              if(equipo!==estructura[ii].descrEquipo){
                equipo = estructura[ii].descrEquipo
                let numCarta = ""
                if(estructura[ii].numCarta){
                  numCarta = estructura[ii].numCarta.toString()
                }
                documento = ({columna1: `EQUIPO: ${equipo}`, columna2: totMecEq[0].ultInforme, columna3: totPtosEq[0].acumUlt, columna4: totPtosEq[0].cantidadTotal, columna5: numCarta})
                tablaRte1.push(documento)
              }
              let numCarta = ""
              if(estructura[ii].numCarta){
                numCarta = estructura[ii].numCarta.toString()
              }
              let totMecComp = await estructuraMec.filter(elemento => elemento.descrPlanta===estructura[ii].descrPlanta&&
                elemento.descrSeccion===estructura[ii].descrSeccion&&elemento.descrEquipo===estructura[ii].descrEquipo
                &&elemento.descrComponente===estructura[ii].descrComponente)
              let totMecCo = _(totMecComp)
                .groupBy('descrComponente')
                .map((obj, key) => ({
                  'descrComponente': key,
                  'ultInforme':_.sumBy(obj, 'ultInforme')
                }))
                .value()
              documento = ({columna1: `COMPONENTE: ${estructura[ii].codComponente} ${estructura[ii].descrComponente}`, columna2: totMecCo[0].ultInforme, columna3: estructura[ii].acumUlt, columna4: estructura[ii].cantidadTotal, columna5: numCarta})

              tablaRte1.push(documento)
            }
          }
          tablaRte1.forEach((elemento3, ii) => {
            let argsUpd = []
            argsUpd.push(elemento3.columna1)
            argsUpd.push(elemento3.columna2)
            argsUpd.push(elemento3.columna3)
            argsUpd.push(elemento3.columna4)
            argsUpd.push(elemento3.columna5)
            tablaRte.push(argsUpd)
          })
          let filaBold =-1
          console.log(tablaRte)

          doc.autoTable({startY: 40,
            // tableLineColor: "black",
            tableLineWidth: 0.1,
            styles: {
              fontSize: 9,
              // lineColor: "black",
              lineWidth: 0.1,
            },
            headStyles: {
              fillColor: "white",
              textColor: "black",
              fontSize: 9,
              halign: "center",
            },
            bodyStyles: {
              fillColor: "#E9E4F0",
              textColor: "black",
              // overflow :'linebreak',
              cellWidth: 'auto',
              cellPadding: 1,
              // rowHeight: 0
              // fontSize: 5,
              // minCellHeight: 2
            },
            columnStyles: {
              1: {halign: "center"},
              2: {halign: "center"},
              3: {halign: "center"},
              4: {halign: "center"}
            },

            didParseCell(data) {
              if(data.row.index !== -1 && data.section==='head'){
                if(data.cell.raw==='TABLA DE CONTENIDO'){
                  data.cell.colSpan = 5
                }
              }
              if(data.row.index !== -1 && data.section==='body'){
                if(data.cell.text[0].substr(0, 6)==='PLANTA'||data.cell.text[0].substr(0, 6)==='SECCIO'||
                    data.cell.text[0].substr(0, 6)==='EQUIPO' || data.cell.text[0].substr(0, 6)==='EMPRES'){
                  filaBold = data.row.index
                }
                if(filaBold===data.row.index){
                  data.row.cells[data.column.index].styles.fontStyle = 'bold';
                }
              }
            },
            alternateRowStyles: {
              fillColor: "white",
              textColor: "black"
            },
            head: [["TABLA DE CONTENIDO", "", "", "", ""],
                    ["", {content: "CANT. DE MECANISMOS", styles: {halign: "center"}}, {content: "CANT. DE TAREAS DE LUB.", styles: {halign: "center"}}, {content: "PUNTOS LUB. EN TAREAS", styles: {halign: "center"}}, {content: "CARTA No.", styles: {halign: "center"}}]],
            body: tablaRte,
            // margin: {top: 40, left: 12, right: 12}})
            margin: {top: 40, left: 12, right: 25, bottom: 25}})
          //FIN TABLA DE CONTENIDO
          doc.addPage()
          //MECANISMOS POR COMPONENTE
            for(let ii=0; ii<estructura.length; ii++){
              doc.setFillColor('#E9E4F0');
              doc.lines([[(widthDoc/2)-12,0],[0,5],[0-(widthDoc/2)+12,0]], 12,36, [1,1], 'F', true)
              doc.lines([[(widthDoc/2)-12,0],[0,5],[0-(widthDoc/2)+12,0]], (widthDoc/2),36, [1,1], 'F', true)
              
              doc.lines([[(widthDoc/2)-12,0],[0,5],[0-(widthDoc/2)+12,0]], 12,41, [1,1], 'F', true)
              doc.lines([[(widthDoc/2)-12,0],[0,5],[0-(widthDoc/2)+12,0]], (widthDoc/2),41, [1,1], 'F', true)

              doc.lines([[(widthDoc/2)-12,0],[0,5],[0-(widthDoc/2)+12,0]], 12,46, [1,1], 'F', true)
              doc.lines([[(widthDoc/2)-12,0],[0,5],[0-(widthDoc/2)+12,0]], (widthDoc/2),46, [1,1], 'F', true)
        
              doc.lines([[(widthDoc)-24,0],[0,5],[0-(widthDoc)+24,0]], 12,51, [1,1], 'F', true)

              doc.lines([[(widthDoc/4)-12,0],[0,5],[0-(widthDoc/4)+12,0]], (widthDoc/4)*3,46, [1,1], 'F', true)

              doc.setDrawColor('black');
              doc.lines([[(widthDoc/2)-12,0],[0,5],[0-(widthDoc/2)+12,0]], 12,36, [1,1], 'S', true)
              doc.lines([[(widthDoc/2)-12,0],[0,5],[0-(widthDoc/2)+12,0]], (widthDoc/2),36, [1,1], 'S', true)
              
              doc.lines([[(widthDoc/2)-12,0],[0,5],[0-(widthDoc/2)+12,0]], 12,41, [1,1], 'S', true)
              doc.lines([[(widthDoc/2)-12,0],[0,5],[0-(widthDoc/2)+12,0]], (widthDoc/2),41, [1,1], 'S', true)

              doc.lines([[(widthDoc/2)-12,0],[0,5],[0-(widthDoc/2)+12,0]], 12,46, [1,1], 'S', true)
              doc.lines([[(widthDoc/2)-12,0],[0,5],[0-(widthDoc/2)+12,0]], (widthDoc/2),46, [1,1], 'S', true)

              doc.rect(12, 51, widthDoc-24, 5)   

              doc.lines([[(widthDoc/4)-12,0],[0,5],[0-(widthDoc/4)+12,0]], (widthDoc/4)*3,46, [1,1], 'S', true)

              doc.setFontSize(8);
              doc.setFontStyle('bold');
              doc.text(`PLANTA: ${estructura[ii].descrPlanta}`,14, 40)
              doc.text(`CODIGO: ${estructura[ii].codPlanta}`, (widthDoc/2)+2, 40)
              doc.text(`SECCION: ${estructura[ii].descrSeccion}`,14, 45)
              doc.text(`CODIGO: ${estructura[ii].codSeccion}`, (widthDoc/2)+2, 45)

              doc.text(`EQUIPO: ${estructura[ii].descrEquipo}`,14, 50)
              doc.text(`CODIGO: ${estructura[ii].codEquipo}`, (widthDoc/2)+2, 50)

              let numCarta = ""
              if(estructura[ii].numCarta){
                numCarta = estructura[ii].numCarta.toString()
              }
              doc.text(`No CL ${numCarta}`, widthDoc-50, 50, 'left')
              doc.text(`COMPONENTE: ${estructura[ii].descrComponente} CODIGO: ${estructura[ii].codComponente}`,widthDoc/2, 55, { align: 'center' })

              const mecanismos1 = list.filter(elemento => elemento.descrPlanta===estructura[ii].descrPlanta&&
                elemento.descrSeccion===estructura[ii].descrSeccion&&elemento.descrEquipo===estructura[ii].descrEquipo&&
                elemento.puntosLub!=="")
              mecanismos1.forEach((elemento1, iii) => {
                mecanismos1[iii].indice = iii
              })

              tablaRte = []
              let descrComponente = ""
              let modoTarea = ''
              let requiereSISO = ''
              mecanismos1.forEach((elemento1, iii) => {
                if(elemento1.modoTarea){
                  modoTarea = elemento1.modoTarea
                } 
                if(elemento1.requiereSISO){
                  requiereSISO = elemento1.requiereSISO
                }
                let argsUpd = []
                
                if(descrComponente!==elemento1.descrComponente && iii>0){
                  descrComponente = elemento1.descrComponente
                  argsUpd.push(`COMPONENTE: ${elemento1.descrComponente} CODIGO: ${elemento1.codComponente}`)
                  tablaRte.push(argsUpd)
                  argsUpd = []
                }else{
                  descrComponente = elemento1.descrComponente
                }
                argsUpd.push(elemento1.descrMecanismo)
                argsUpd.push("")
                argsUpd.push(new Intl.NumberFormat('de-DE').format(elemento1.cantidadTotal) + `(${elemento1.abrevUnidad})`)
                argsUpd.push(new Intl.NumberFormat('de-DE').format(elemento1.cantidad) + `(${elemento1.abrevUnidad})`)
                argsUpd.push(elemento1.puntosLub)
                argsUpd.push(elemento1.descrFrecuencia)
                argsUpd.push(elemento1.descrMetodo)
                argsUpd.push(`${elemento1.descrTarea} / ${modoTarea} / ${requiereSISO}`)
                // argsUpd.push(elemento1.codProcedimiento)
                argsUpd.push("")
                // if(ficha){
                  // argsUpd.push("")
                // }else{
                  argsUpd.push(elemento1.descrLubricante)
                // }
                argsUpd.push(elemento1.claseLub)
                argsUpd.push(elemento1.descrGrado)
                argsUpd.push(elemento1.tipoLub)
                argsUpd.push(elemento1.categoriaLub)
                tablaRte.push(argsUpd)
              })
              let descrPlanta = estructura[ii].descrPlanta
              let descrSeccion = estructura[ii].descrSeccion
              let descrEquipo = estructura[ii].descrEquipo

              for(let iii=0; iii<mecanismos1.length+1; iii++){
                if(estructura[ii].descrPlanta===descrPlanta&&estructura[ii].descrSeccion===descrSeccion&&
                  estructura[ii].descrEquipo===descrEquipo){
                    if(ii<estructura.length-1 && mecanismos1.length>1){
                      ii += 1
                    }
                }else{
                  ii -= 1
                  iii=mecanismos1.length
                }
              }
              let indice = 0
              let esComp = false
              doc.autoTable({
                startY: 56,
                rowPageBreak: 'avoid',  //cambia de página si la ultima fila queda incompleta
                showHead: 'everyPage',
                // finalY: typeof doc.autoTable.previous.finalY === 'undefined' ? 70 : doc.autoTable.previous.finalY - 40,
                // startY: doc.autoTableEndPosY() + 20,
                tableLineColor: "black",
                tableLineWidth: 0.1,
                styles: {
                  fontSize: 8,
                  lineColor: "black",
                  lineWidth: 0.1
                },
                headStyles: {
                  fillColor: "#E9E4F0",
                  textColor: "black",
                  halign: "center",
                  // valign: "center",
                  cellPadding: 1,
                  fontStyle: "bold",
                  fontSize: 7
                },
                bodyStyles: {
                  // fillColor: "#E9E4F0",
                  fillColor: "white",
                  textColor: "black",
                  halign: "center",
                  // valign: "center",
                  minCellHeight: 20
                },
                columnStyles: {
                  0: {cellWidth: 28.4},
                  1: {cellWidth: 17.7},
                  2: {cellWidth: 10.7},
                  3: {cellWidth: 10.7},
                  4: {cellWidth: 11.7},
                  5: {cellWidth: 17.7},
                  6: {cellWidth: 14.7},
                  7: {cellWidth: 19.7},
                  8: {cellWidth: 22.7},
                  9: {cellWidth: 23.3},
                  10: {cellWidth: 13.7},
                  11: {cellWidth: 10.7},
                  12: {cellWidth: 10.7},
                  13: {cellWidth: 8.7},
                  14: {cellWidth: 16.7},
                },

                didParseCell(data) {
                  if(data.row.index !== -1 && data.section==='head'){
                    if(data.cell.raw==='MECANISMO'||data.cell.raw==='QR MECANISMO'||
                        data.cell.raw==='ROTULO'){
                      data.cell.rowSpan = 2
                    }
                    if(data.cell.raw==='CANTIDAD DE LUBRICANTE'){
                      data.cell.colSpan = 2
                    }
                    if(data.cell.raw==='LUBRICACION'){
                      data.cell.colSpan = 5
                    }
                    if(data.cell.raw==='LUBRICANTE'){
                      data.cell.colSpan = 5
                    }
                  }
                  if(data.row.index !== -1 && data.section==='body'){
                    if(data.column.index === 0){
                      esComp = false
                      if(data.cell.text[0].substr(0, 11)==='COMPONENTE:'){
                        esComp = true
                      }
                    }

                    data.cell.styles.minCellHeight = 20
                    data.cell.styles.fillColor = "white"
                    // data.cell.styles.halign = "left"
                    data.cell.styles.fontStyle = "normal"
                    if(esComp){
                      if(data.column.index===0){
                        data.cell.colSpan = 15
                        data.cell.styles.halign = "center"
                        // data.cell.styles.halign = "left"
                        data.cell.styles.fontStyle = "bold"
                      }
                      data.cell.styles.minCellHeight = 7
                      data.cell.styles.fillColor = "#E9E4F0"
                    }

                  }
                  if(data.row.index !== -1 && data.section==='body' && data.column.index === 9 && !esComp){
                    let ficha = ""

                    let indexLub = allProducto.findIndex( producto => producto.descrLubricante===mecanismos1[indice].descrLubricante)
                    if (indexLub!==-1){
                      if (allProducto[indexLub].ficha==null || allProducto[indexLub].ficha==''){
                      }else{
                        ficha=allProducto[indexLub].ficha
                      }
                    } 
                    // let ficha='PANCARTA ROTULOS DE LUBRICACION.pdf'

                    if(ficha!==""){
                      data.cell.styles.textColor = "#3366BB"
                    }
                  }
                },

                didDrawCell: (data) => {
                  //imagenes en autoTable
                  //https://github.com/simonbengtsson/jsPDF-AutoTable/issues/93
                  if(data.row.index===-1){
                    console.log("ojoooo")
                  }

                  if(data.row.index !== -1 && data.section==='body' && data.column.index === 0){
                    esComp = false
                    if(data.row.index===0){
                      indice = 0
                    }else{
                      if(data.cell.text[0].substr(0, 11)!=='COMPONENTE:'){
                        indice += 1
                      }else{
                        esComp = true
                      }
                    }
                  }

                  if(data.row.index !== -1 && data.section==='body' && data.column.index === 14 && !esComp){
                    if(mecanismos1[indice].archRotulo){
                      let imgSourceCB = new Image();
                      imgSourceCB.src = mecanismos1[indice].archRotulo;
                      doc.convertStringToImageData(imgSourceCB)
                      doc.addImage(imgSourceCB, 'PNG', data.cell.x - 1.5, data.cell.y + 2, 40, 20);
                    }
                  }

                  if(data.row.index !== -1 && data.section==='body' && data.column.index === 1 && !esComp){
                    if(mecanismos1[indice].codigoQR){
                      let canvas = document.createElement("canvas");
                      QRCode.toCanvas(canvas, mecanismos1[indice].codigoQR)
                      let imgSourceQR = canvas.toDataURL("image/svg");
                      doc.addImage(imgSourceQR, 'svg', data.cell.x + 0.5, data.cell.y + 2, 17, 17);
                    }
                  }

                  if(data.row.index !== -1 && data.section==='body' && data.column.index === 8 && !esComp){
                    if(mecanismos1[indice].codProcedimiento){
                      let urlSlcm = 'https://montserratslcm.com/api/procedimientos/'
                      doc.setTextColor('#3366BB');
                      doc.textWithLink(mecanismos1[indice].codProcedimiento, data.cell.x + 2, data.cell.y + 4, {url: 'https://montserratslcm.com/api/procedimientos/' + mecanismos1[indice].nombreArchivo})
                      doc.setTextColor('black');
                    }
                  }
                  if(data.row.index !== -1 && data.section==='body' && data.column.index === 9 && !esComp){
                    let ficha = ""
                    // let ficha='PANCARTA ROTULOS DE LUBRICACION.pdf'

                    let indexLub = allProducto.findIndex( producto => producto.descrLubricante===mecanismos1[indice].descrLubricante)
                    if (indexLub!==-1){
                      if (allProducto[indexLub].ficha==null || allProducto[indexLub].ficha==''){
                      }else{
                        ficha=allProducto[indexLub].ficha
                      }
                    } 
                    if(ficha!==""){
                      let urlSlcm = 'https://montserratslcm.com/api/fichas/'
                      doc.link(data.cell.x + 2, data.cell.y + 4, 12.7, 16, { url: urlSlcm + ficha});
                    }
                  }
                },
                alternateRowStyles: {
                  textColor: "black"
                },
                head: [["MECANISMO", "QR MECANISMO", "CANTIDAD DE LUBRICANTE", "", "LUBRICACION", "", "", "", "", "LUBRICANTE", "", "", "", "", "ROTULO"],
                        ["", "", "TOTAL", "TAREA", "PUNTOS", "FRECUENCIA", "METODO", "TAREA/MODO/SISO", "PROCEDIMIENTO", "DESCRIPCION", "CLASE", "GRADO", "TIPO", "CAT.", ""]],
                body: tablaRte,
                margin: {top: 42.2, left: 12, right: 24, bottom: 25}})
                if(ii<estructura.length){
                //IMAGENES POR EQUIPO
                const estructura1 = await list2.filter(elemento => elemento.descrPlanta===descrPlanta&&
                  elemento.descrSeccion===descrSeccion&&elemento.descrEquipo===descrEquipo&&elemento.nombreImagen!==null)

                if(estructura1.length>0||(estructura1.length===0&&ii<estructura.length-1)){
                  doc.addPage()
                }
                for(let iiii=0; iiii<estructura1.length; iiii++){            
                  const imagenes1 = await list2.filter(elemento => elemento.descrPlanta===estructura1[iiii].descrPlanta&&
                    elemento.descrSeccion===estructura1[iiii].descrSeccion&&elemento.descrEquipo===estructura1[iiii].descrEquipo)

                  tablaRte = []
                  imagenes1.forEach((elemento1, iii) => {
                    let argsUpd = []
                    argsUpd.push("")
                    tablaRte.push(argsUpd)
                  })
                  let descrPlanta = estructura1[iiii].descrPlanta
                  let descrSeccion = estructura1[iiii].descrSeccion
                  let descrEquipo = estructura1[iiii].descrEquipo
                  for(let iii=0; iii<imagenes1.length; iii++){
                    if(estructura1[iiii].descrPlanta===descrPlanta&&estructura1[iiii].descrSeccion===descrSeccion&&
                      estructura1[iiii].descrEquipo===descrEquipo){
                        if(iiii<estructura1.length-1){
                          iiii += 1
                        }
                    }else{
                      iiii -= 1
                      iii=imagenes1.length
                    }
                  }
                  console.log(descrPlanta, descrSeccion, descrEquipo)
                  doc.autoTable({
                    startY: 36,
                    rowPageBreak: 'avoid',  //cambia de página si la ultima fila queda incompleta
                    showHead: 'everyPage',
                    tableLineColor: "black",
                    // tableLineWidth: 0.1,
                    styles: {
                      fontSize: 8,
                    },
                    headStyles: {
                      fillColor: "#E9E4F0",
                      lineColor: "black",
                      lineWidth: 0.1,
                      textColor: "black",
                      halign: "left",
                      cellPadding: 1,
                      fontStyle: "bold",
                      fontSize: 8
                    },
                    bodyStyles: {
                      halign: "center",
                      minCellHeight: 133
                    },
                    columnStyles: {
                      0: {cellWidth: 25},
                      1: {cellWidth: 93},
                      2: {cellWidth: 81},
                      3: {cellWidth: 41},
                    },

                    didParseCell(data) {
                      if(data.row.index !== -1 && data.section==='head'){
                        if(data.row.index===0){
                          if(data.column.index===0){
                            // data.cell.styles.halign = "left"
                            data.cell.colSpan = 2
                            data.cell.text[0] = "PLANTA: " + imagenes1[0].descrPlanta
                          }
                          if(data.column.index===2){
                            // data.cell.styles.halign = "left"
                            data.cell.colSpan = 2
                            data.cell.styles.halign = "left"
                            data.cell.text[0] = "CODIGO: " + imagenes1[0].codPlanta
                          }
                        }
                        if(data.row.index===1){
                          if(data.column.index===0){
                            // data.cell.styles.halign = "left"
                            data.cell.colSpan = 2
                            data.cell.text[0] = "SECCION: " + imagenes1[0].descrSeccion
                          }
                          if(data.column.index===2){
                            // data.cell.styles.halign = "left"
                            data.cell.colSpan = 2
                            data.cell.text[0] = "CODIGO: " + imagenes1[0].codSeccion
                          }
                        }
                        if(data.row.index===2){
                          if(data.column.index===0){
                            // data.cell.styles.halign = "left"
                            data.cell.colSpan = 2
                            data.cell.text[0] = "EQUIPO: " + imagenes1[0].descrEquipo
                          }
                          if(data.column.index===2){
                            // data.cell.styles.halign = "left"
                            // data.cell.colSpan = 2
                            data.cell.text[0] = "CODIGO:" + imagenes1[0].codEquipo
                          }
                          let numCarta = ""
                          if(imagenes1[0].numCarta){
                            numCarta = imagenes1[0].numCarta.toString()
                          }
                          if(data.column.index===3){
                            // data.cell.styles.halign = "left"
                            // data.cell.colSpan = 2
                            data.cell.text[0] = "No CL: " + numCarta
                          }
                        }
                      }
                      if(data.row.index !== -1 && data.section==='body'){
                        data.cell.styles.fillColor = "white"
                        if(data.column.index===1){
                          data.cell.colSpan = 4
                        }
                      }
                    },

                    didDrawCell: (data) => {
                      //imagenes en autoTable
                      //https://github.com/simonbengtsson/jsPDF-AutoTable/issues/93
                      if(data.row.index===-1){
                        console.log("ojoooo")
                      }
                      // console.log(imagenes1[data.row.index])
                      if(data.row.index !== -1 && data.section==='body' && data.column.index === 1){
                        // data.cell.colSpan = 3
                        let imgSourceCB = new Image();
                        let urlSlcm = 'https://montserratslcm.com/api/imgeq/'
                        imgSourceCB.src = urlSlcm + imagenes1[data.row.index].descrEmpresa.replace(/\./g,'') + "/" + imagenes1[data.row.index].nombreImagen;
                        // console.log(imgSourceCB.src)
                        doc.convertStringToImageData(imgSourceCB)

                        let ancho = 200
                        let alto = 133
                        let nuevoAncho = imagenes1[data.row.index].anchoImagen
                        let nuevoAlto = imagenes1[data.row.index].altoImagen
                        if(imagenes1[data.row.index].anchoImagen>imagenes1[data.row.index].altoImagen){
                          nuevoAncho = ancho
                          let porcEscalado = (imagenes1[data.row.index].anchoImagen * 100) / ancho
                          nuevoAlto = (100 * imagenes1[data.row.index].altoImagen) / porcEscalado
                          if(parseInt(nuevoAlto, 10)>133){
                            porcEscalado = (parseInt(nuevoAlto, 10) * 100) / 133
                            nuevoAncho = (100 * 200) / porcEscalado
                            nuevoAlto = 133
                          }
                        }else{
                          nuevoAlto = alto
                          let porcEscalado = (imagenes1[data.row.index].altoImagen * 100) / alto
                          nuevoAncho = (100 * imagenes1[data.row.index].anchoImagen) / porcEscalado
                          if(parseInt(nuevoAncho, 10)>200){
                            porcEscalado = (parseInt(nuevoAncho, 10) * 100) / 200
                            nuevoAlto = (100 * 133) / porcEscalado
                            nuevoAncho = 200
                          }
                        }
                        nuevoAncho = parseInt(nuevoAncho, 10)
                        nuevoAlto = parseInt(nuevoAlto, 10)
                        doc.addImage(imgSourceCB, 'PNG', data.cell.x + ((216 - (nuevoAncho)) / 2), data.cell.y + 2, nuevoAncho, nuevoAlto, undefined, 'FAST');
                      }
                    },
                    head: [["", "", "", ""], ["", "", "", ""], ["", "", "", ""]],
                    body: tablaRte,
                    margin: {top: 42.1, left: 14, right: 14, bottom: 25}})
                  
                  if(iiii<estructura1.length && ii<estructura.length-1){
                    doc.addPage()
                  }
                }
                //FIN IMAGENES POR EQUIPO
              }
            }
            //FIN MECANISMOS POR COMPONENTE

            const pageCount = doc.internal.getNumberOfPages();
            // For each page, print the page number and the total pages
            for(var i = 1; i <= pageCount; i++) {
                // Go to page i
                doc.setPage(i);

  //ENCABEZADO DE PAGINA
                doc.setFontSize(14);
                doc.setFontType("bold");
                doc.text("CARTAS DE LUBRICACION", widthDoc/2, 14, 'center')
                doc.text(list[0].descrEmpresa, widthDoc/2, 24, 'center')
                doc.setFontSize(10);
                // doc.text("TABLA DE CONTENIDO", widthDoc/2, 30, 'center')

                let dirSlcm = 'images/logos/LCMSAS.png'

                let miLista = document.getElementById("miLista")
                let dirEmpresa = 'images/logos/' + miLista.options[miLista.selectedIndex].attributes[0].value
                let imgSource = new Image();
                try{
                  imgSource.src = dirSlcm;
                  doc.convertStringToImageData(imgSource)
                  doc.addImage(imgSource, 'PNG', 12, 12, 56, 20);
                }catch{
                  console.log("Logo de LCM no existe")
                }

                try{
                  imgSource.src = dirEmpresa;
                  doc.convertStringToImageData(imgSource)
                  if(list[0].descrEmpresa==='CELSIA' || list[0].descrEmpresa==='CELSIA COLOMBIA' || list[0].descrEmpresa==='TRIBOS INGENIERIA SAS' || list[0].descrEmpresa==='URRA S.A .E.S.P' || list[0].descrEmpresa==='BIOENERGY'){
                    doc.addImage(imgSource, 'PNG', widthDoc-49, 10, 25, 25);
                  }else{
                    doc.addImage(imgSource, 'PNG', widthDoc-56-12, 12, 50, 20);
                  }
                }catch{
                  console.log("Logo de la empresa no existe")
                }
  //FIN ENCABEZADO DE PAGINA

                doc.text('Pag ' + String(i) + ' de ' + String(pageCount), 12, heightDoc-12, 'left')
                doc.text(fechaHoraHoy.substr(0, 10) + " " + fechaHoraHoy.substr(11, 5), widthDoc-50, heightDoc-12, 'left')
                // doc.text('Pag ' + String(i) + ' de ' + String(pageCount),210-20,297-30,null,null,"left");
            } 
            document.body.style.cursor = 'default'
          let nameDoc = `${list[0].descrEmpresa}.pdf`
          console.log(nameDoc)
          doc.save(nameDoc)
        }else{
          alert(`La empresa ${args.descrEmpresa} no tiene información de Cartas de Lubricación`)
        }
      }
    }
    this.setState({permiteBtn1: true, open: false, confirmaAct: false})
  }


  handleQuestionUpdDel = async (ev, btn) => {
    // console.log(btn, this.state.confirmaAct, this.state.procBtn)
    var btnPress = await ev.target.attributes[0].value
    // console.log(btnPress)
    if(btnPress==="btnUpdDel" && !this.state.confirmaAct && this.state.procBtn===0){
      this.setState({open: true})
      this.setState({permiteBtn1: btn==="1"?true:false, permiteBtn2: btn==="2"?true:false})
    }else{
      this.setState({open: false})
      this.setState({procBtn: 0})
      this.setState({permiteBtn1: true, permiteBtn2: true})
    };
    if(btnPress==="No"){
      this.setState({open: false})
      this.setState({procBtn: 0})
      this.setState({permiteBtn1: true, permiteBtn2: true})
    };
    if(btnPress==="Si"){
      this.setState({confirmaAct: true})
      this.setState({open: false})
      this.setState({procBtn: 1})
      this.setState({permiteBtn1: btn==="1"?true:false, permiteBtn2: btn==="2"?true:false})
      // console.log(this.state.permiteBtn1, this.state.permiteBtn2)
      const myBtn = document.getElementById("btnUpdDel");
      myBtn.click()
    }

  }

  componentDidUpdate(prevProps, prevState){
    if(this.props.list!==prevProps.list){
      this.setState({listCL: this.props.list})
    }
    if(this.props.list2!==prevProps.list2){
      this.setState({listImg: this.props.list2})
    }
  }

handleGenExc = async (ev, args)=>{
  document.body.style.cursor = 'wait'

  let unidad = ""
  let allFrecuencia = this.props.allFrecuencia.allFrecuencia
  let allAplicacion = this.props.allAplicacion.allAplicacion
  let allUsuarios = this.props.allUsuarios.allUsuarios

  let nombreUsuario = ''
  let indexUsu = allUsuarios.findIndex( usuario => usuario.email===localStorage.getItem('userLogin') )
  if(indexUsu!==-1){
    nombreUsuario=allUsuarios[indexUsu].nombreUsuario
  }

  let argsBuscarEmp = {tipoqry: `[{$match: {anexos: 'S'}}]`}

  let {data} = await this.props.allEmpresaRtes.refetch(argsBuscarEmp)
  let empresas = await data.allEmpresaRtes
  let actEmpresa = []

  if(empresas.length>0){       
    for(let i=0; i<empresas.length; i++){
      let idEmpresa = empresas[i]._id
      let descrEmpresa =  empresas[i].descrEmpresa
      let rutaLogo=empresas[i].rutaLogo?empresas[i].rutaLogo:''
      let lubricantes = [], lubricantes1 = [] 
      let tareas = [], tareas1 = []
      let protectores=[], protectores1=[] 
      let aceiteras=[], aceiteras1=[]
      let modo=[], modo1=[]
      let siso=[], siso1=[]
      let reportes=[]
      let argsLinea=[]
      let actEmpresaMany = [], actEmpresaMany1 = []
      let argsUpdEmp = {}

      let argsBuscar=""
      argsBuscar += `'descrEmpresa': '${empresas[i].descrEmpresa}'`
      let response = await this.props.fecha({
        variables: {}
      });
      const {fechaHoraHoy} = response.data.fecha

// ***** ARMAR ARRAY DE LUBRICANTES ***************************

      let argsBuscarPl = {tipoqry: `[
        {"$unwind": "$secciones"},
        {"$unwind": "$secciones.equipos"},
        {"$unwind": "$secciones.equipos.componentes"},
        {"$unwind": "$secciones.equipos.componentes.mecanismos"},
        {$project: {_id: 1,
          descrEmpresa: 1, codPlanta: 1, descrPlanta: 1,
          codSeccion: '$secciones.codSeccion', descrSeccion: '$secciones.descrSeccion',
          codEquipo: '$secciones.equipos.codEquipo', descrEquipo: '$secciones.equipos.descrEquipo',
          codComponente: '$secciones.equipos.componentes.codComponente',
          descrComponente: '$secciones.equipos.componentes.descrComponente',
          descrMecanismo: '$secciones.equipos.componentes.mecanismos.descrMecanismo',
          tipoLub: '$secciones.equipos.componentes.mecanismos.tipoLub',
          descrLubricante: '$secciones.equipos.componentes.mecanismos.descrLubricante'
        }}, {$match: {${argsBuscar}}}, 
        {$group: {_id: {descrPlanta: '$descrPlanta', descrSeccion: '$descrSeccion', descrEquipo: '$descrEquipo', tipoLub: '$tipoLub', descrLubricante: '$descrLubricante'}}},
        {$project: {descrPlanta: '$_id.descrPlanta', descrSeccion: '$_id.descrSeccion', descrEquipo: '$_id.descrEquipo', tipoLub: '$_id.tipoLub', descrLubricante: '$_id.descrLubricante'}},
          {$sort: {descrPlanta: 1, descrSeccion: 1, descrEquipo: 1, tipoLub: 1, descrLubricante: 1}}]`}

      let {data} = await this.props.allPlantaRtes3.refetch(argsBuscarPl)
      let estructura = await data.allPlantaRtes

      if(estructura.length>0){       
        for(let ii=0; ii<estructura.length; ii++){
          if(estructura[ii].tipoLub==='Aceite'){
            unidad='Galones'
          }else{
            if(estructura[ii].tipoLub==='Grasa'){
              unidad='Kilos'
            }else{
              unidad='Unidad'
            }
          }
          lubricantes1 = [{planta:estructura[ii].descrPlanta, seccion:estructura[ii].descrSeccion, equipo:estructura[ii].descrEquipo, tipo:estructura[ii].tipoLub, lubricante:estructura[ii].descrLubricante, unidad:unidad, total:0, mensual:0, anual:0}]
          lubricantes.push(lubricantes1)
        }


// ***** ARMAR ARRAY DE TAREAS ***************************

        let argsBuscarPl = {tipoqry: `[
          {"$unwind": "$secciones"},
          {"$unwind": "$secciones.equipos"},
          {"$unwind": "$secciones.equipos.componentes"},
          {"$unwind": "$secciones.equipos.componentes.mecanismos"},
          {"$unwind": "$secciones.equipos.componentes.mecanismos.programacion"},
          {$project: {_id: 1,
            descrEmpresa: 1, descrPlanta: 1,
            descrSeccion: '$secciones.descrSeccion',
            descrEquipo: '$secciones.equipos.descrEquipo',
            descrComponente: '$secciones.equipos.componentes.descrComponente',
            descrMecanismo: '$secciones.equipos.componentes.mecanismos.descrMecanismo',
            descrTarea: '$secciones.equipos.componentes.mecanismos.programacion.descrTarea'
          }}, {$match: {${argsBuscar}}}, 
          {$group: {_id: {descrPlanta: '$descrPlanta', descrSeccion: '$descrSeccion', descrEquipo: '$descrEquipo', descrTarea: '$descrTarea'}}},
          {$project: {descrPlanta: '$_id.descrPlanta', descrSeccion: '$_id.descrSeccion', descrEquipo: '$_id.descrEquipo', descrTarea: '$_id.descrTarea'}},
            {$sort: {descrPlanta: 1, descrSeccion: 1, descrEquipo: 1, descrTarea: 1}}]`}

        if(2>1){
          let {data} = await this.props.allPlantaRtes3.refetch(argsBuscarPl)
          let estructura1 = await data.allPlantaRtes

          for(let ii=0; ii<estructura1.length; ii++){
            tareas1 = [{planta:estructura1[ii].descrPlanta, seccion:estructura1[ii].descrSeccion, equipo:estructura1[ii].descrEquipo, tarea:estructura1[ii].descrTarea, total:0, mensual:0, anual:0}]
            tareas.push(tareas1)
          }
        }

// ***** ARMAR ARRAY DE I / O ***************************
            argsBuscarPl = {tipoqry: `[
              {"$unwind": "$secciones"},
              {"$unwind": "$secciones.equipos"},
              {"$unwind": "$secciones.equipos.componentes"},
              {"$unwind": "$secciones.equipos.componentes.mecanismos"},
              {"$unwind": "$secciones.equipos.componentes.mecanismos.programacion"},
              {$project: {_id: 1,
                descrEmpresa: 1, descrPlanta: 1,
                descrSeccion: '$secciones.descrSeccion',
                descrEquipo: '$secciones.equipos.descrEquipo',
                descrComponente: '$secciones.equipos.componentes.descrComponente',
                descrMecanismo: '$secciones.equipos.componentes.mecanismos.descrMecanismo',
                modoTarea: '$secciones.equipos.componentes.mecanismos.programacion.modoTarea'
              }}, {$match: {${argsBuscar}}}, 
              {$group: {_id: {descrPlanta: '$descrPlanta', descrSeccion: '$descrSeccion', descrEquipo: '$descrEquipo', modoTarea: '$modoTarea'}}},
              {$project: {descrPlanta: '$_id.descrPlanta', descrSeccion: '$_id.descrSeccion', descrEquipo: '$_id.descrEquipo', modoTarea: '$_id.modoTarea'}},
                {$sort: {descrPlanta: 1, descrSeccion: 1, descrEquipo: 1, modoTarea: 1}}]`}

            if(2>1){
              let {data} = await this.props.allPlantaRtes3.refetch(argsBuscarPl)
              let estructura1 = await data.allPlantaRtes

              for(let ii=0; ii<estructura1.length; ii++){
                // console.log(estructura1[ii].modoTarea)
                let modoTarea='Operando'
                if(estructura1[ii].modoTarea && estructura1[ii].modoTarea==='O'){
                  modoTarea='En parada'
                }
                modo1 = [{planta:estructura1[ii].descrPlanta, seccion:estructura1[ii].descrSeccion, equipo:estructura1[ii].descrEquipo, modo:modoTarea, total:0, mensual:0, anual:0}]
                modo.push(modo1)
              }
            }


// ***** ARMAR ARRAY DE SISO ***************************
            argsBuscarPl = {tipoqry: `[
              {"$unwind": "$secciones"},
              {"$unwind": "$secciones.equipos"},
              {"$unwind": "$secciones.equipos.componentes"},
              {"$unwind": "$secciones.equipos.componentes.mecanismos"},
              {"$unwind": "$secciones.equipos.componentes.mecanismos.programacion"},
              {$match: {'secciones.equipos.componentes.mecanismos.programacion.minutos': {$ne: ""},
                    'secciones.equipos.componentes.mecanismos.programacion.requiereSISO': {$ne: ""}}},
              {$project: {_id: 1,
                descrEmpresa: 1, descrPlanta: 1,
                descrSeccion: '$secciones.descrSeccion',
                descrEquipo: '$secciones.equipos.descrEquipo',
                descrComponente: '$secciones.equipos.componentes.descrComponente',
                descrMecanismo: '$secciones.equipos.componentes.mecanismos.descrMecanismo',
                requiereSISO: '$secciones.equipos.componentes.mecanismos.programacion.requiereSISO'
              }}, {$match: {${argsBuscar}}}, 
              {$group: {_id: {descrPlanta: '$descrPlanta', descrSeccion: '$descrSeccion', descrEquipo: '$descrEquipo', requiereSISO: '$requiereSISO'}}},
              {$project: {descrPlanta: '$_id.descrPlanta', descrSeccion: '$_id.descrSeccion', descrEquipo: '$_id.descrEquipo', requiereSISO: '$_id.requiereSISO'}}]`}

            if(2>1){
              let {data} = await this.props.allPlantaRtes3.refetch(argsBuscarPl)
              let estructura1 = await data.allPlantaRtes

              for(let ii=0; ii<estructura1.length; ii++){
                let requiereSISO='No requiere SISO'
                if(estructura1[ii].requiereSISO && (estructura1[ii].requiereSISO==='S' || estructura1[ii].requiereSISO==='Si' || estructura1[ii].requiereSISO==='si' || estructura1[ii].requiereSISO==='SI')){
                  requiereSISO='Requiere SISO'
                }
                siso1 = [{planta:estructura1[ii].descrPlanta, seccion:estructura1[ii].descrSeccion, equipo:estructura1[ii].descrEquipo, siso:requiereSISO, total:0, mensual:0, anual:0}]
                siso.push(siso1)
              }
            }



// ***** VOLUMEN TOTAL DE LUBRICANTES: ***************************

        argsBuscarPl = {tipoqry: `[
          {"$unwind": "$secciones"},
          {"$unwind": "$secciones.equipos"},
          {"$unwind": "$secciones.equipos.componentes"},
          {"$unwind": "$secciones.equipos.componentes.mecanismos"},
          {$project: {_id: 1,
            descrEmpresa: 1, codPlanta: 1, descrPlanta: 1,
            codSeccion: '$secciones.codSeccion', descrSeccion: '$secciones.descrSeccion',
            codEquipo: '$secciones.equipos.codEquipo', descrEquipo: '$secciones.equipos.descrEquipo',
            codComponente: '$secciones.equipos.componentes.codComponente',
            descrComponente: '$secciones.equipos.componentes.descrComponente',
            descrMecanismo: '$secciones.equipos.componentes.mecanismos.descrMecanismo',
            tipoLub: '$secciones.equipos.componentes.mecanismos.tipoLub',
            descrLubricante: '$secciones.equipos.componentes.mecanismos.descrLubricante',
            descrUnidad: '$secciones.equipos.componentes.mecanismos.descrUnidad',
            cantidadTotal: '$secciones.equipos.componentes.mecanismos.cantidadTotal'
          }}, {$match: {${argsBuscar}}}, 
          {$group: {_id: {descrPlanta: '$descrPlanta', descrSeccion: '$descrSeccion', descrEquipo: '$descrEquipo', tipoLub: '$tipoLub', descrLubricante: '$descrLubricante', descrUnidad: '$descrUnidad'},
                    totalCantidad: {$sum: {$toDouble: '$cantidadTotal'}}}},
          {$project: {descrPlanta: '$_id.descrPlanta', descrSeccion: '$_id.descrSeccion', descrEquipo: '$_id.descrEquipo', tipoLub: '$_id.tipoLub', descrLubricante: '$_id.descrLubricante', 
          descrUnidad: '$_id.descrUnidad', ultInforme: {$toDouble: '$totalCantidad'}}},
            {$sort: {descrPlanta: 1, descrSeccion: 1, descrEquipo: 1, tipoLub: 1, descrLubricante: 1, descrUnidad: 1}}]`}
  
        if(2>1){
          let {data} = await this.props.allPlantaRtes3.refetch(argsBuscarPl)
          let estructura1 = await data.allPlantaRtes
          for(let ii=0; ii<estructura1.length; ii++){
            let nomLub = estructura1[ii].descrLubricante, nomPla = estructura1[ii].descrPlanta, nomSec = estructura1[ii].descrSeccion, nomEq = estructura1[ii].descrEquipo
            let indexLub = 0
            lubricantes.forEach(async (elemento, iii) => {
              if(lubricantes[iii][0].lubricante===nomLub && lubricantes[iii][0].planta===nomPla && lubricantes[iii][0].seccion===nomSec && lubricantes[iii][0].equipo===nomEq){
                indexLub = iii
              }
            })
            
            if(estructura1[ii].tipoLub==='Aceite'){
              if(estructura1[ii].descrUnidad==='Galón' || estructura1[ii].descrUnidad==='Galon' || estructura1[ii].descrUnidad==='galón' || estructura1[ii].descrUnidad==='galon'){
                lubricantes[indexLub][0].total=lubricantes[indexLub][0].total + estructura1[ii].ultInforme
              }else{
                switch(estructura1[ii].descrUnidad){
                  case 'Litros':
                    lubricantes[indexLub][0].total=lubricantes[indexLub][0].total + estructura1[ii].ultInforme*0.264;
                    break
                  case 'Mililitro':
                    lubricantes[indexLub][0].total=lubricantes[indexLub][0].total + estructura1[ii].ultInforme*0.00264;
                    break
                  case 'Onza':
                    lubricantes[indexLub][0].total=lubricantes[indexLub][0].total + estructura1[ii].ultInforme*0.0078125;
                    break
                  case 'Gramos':
                    lubricantes[indexLub][0].total=lubricantes[indexLub][0].total + estructura1[ii].ultInforme/3657.14826;
                  break
                }
              }
            }else{
              if(estructura1[ii].tipoLub==='Grasa'){
                if(estructura1[ii].descrUnidad==='Gramos' || estructura1[ii].descrUnidad==='gramos'){
                  lubricantes[indexLub][0].total=lubricantes[indexLub][0].total + estructura1[ii].ultInforme/1000
                }else{
                  switch(estructura1[ii].descrUnidad){
                    case 'Onza':
                      lubricantes[indexLub][0].total=lubricantes[indexLub][0].total + estructura1[ii].ultInforme*0.0283495;
                      break
                    case 'Mililitro':
                      lubricantes[indexLub][0].total=lubricantes[indexLub][0].total + estructura1[ii].ultInforme/1000;
                      break
                    case 'Litros':
                      lubricantes[indexLub][0].total=lubricantes[indexLub][0].total + estructura1[ii].ultInforme;
                      break
                  }
                }
              }else{

              }
            }
            lubricantes[indexLub][0].total=lubricantes[indexLub][0].total
          }
        }


// ***** CONSUMO DE LUBRICANTES POR MES Y AÑO ***************************

        argsBuscarPl = {tipoqry: `[
          {"$unwind": "$secciones"},
          {"$unwind": "$secciones.equipos"},
          {"$unwind": "$secciones.equipos.componentes"},
          {"$unwind": "$secciones.equipos.componentes.mecanismos"},
          {"$unwind": "$secciones.equipos.componentes.mecanismos.programacion"},
          {$match: {'secciones.equipos.componentes.mecanismos.programacion.cantidad': {$ne: ""}}},
          {$project: {_id: 1,
            descrEmpresa: 1, codPlanta: 1, descrPlanta: 1,
            codSeccion: '$secciones.codSeccion', descrSeccion: '$secciones.descrSeccion',
            codEquipo: '$secciones.equipos.codEquipo', descrEquipo: '$secciones.equipos.descrEquipo',
            codComponente: '$secciones.equipos.componentes.codComponente',
            descrComponente: '$secciones.equipos.componentes.descrComponente',
            descrMecanismo: '$secciones.equipos.componentes.mecanismos.descrMecanismo',
            tipoLub: '$secciones.equipos.componentes.mecanismos.tipoLub',
            descrLubricante: '$secciones.equipos.componentes.mecanismos.descrLubricante',
            descrUnidad: '$secciones.equipos.componentes.mecanismos.descrUnidad',
            descrFrecuencia: '$secciones.equipos.componentes.mecanismos.programacion.descrFrecuencia',
            descrFrecuenciaPre: '$secciones.equipos.componentes.mecanismos.programacion.descrFrecuenciaPre',
            cantidad: '$secciones.equipos.componentes.mecanismos.programacion.cantidad'
          }}, {$match: {${argsBuscar}}}, 
          {$group: {_id: {descrPlanta: '$descrPlanta', descrSeccion: '$descrSeccion', descrEquipo: '$descrEquipo', tipoLub: '$tipoLub', descrLubricante: '$descrLubricante', 
                    descrUnidad: '$descrUnidad', descrFrecuencia: '$descrFrecuencia', 
                    descrFrecuenciaPre: '$descrFrecuenciaPre'},
                    totalCantidad: {$sum: {$toDouble: '$cantidad'}}}},
          {$project: {descrPlanta: '$_id.descrPlanta', descrSeccion: '$_id.descrSeccion', descrEquipo: '$_id.descrEquipo', tipoLub: '$_id.tipoLub', descrLubricante: '$_id.descrLubricante', 
          descrFrecuencia: '$_id.descrFrecuencia', descrFrecuenciaPre: '$_id.descrFrecuenciaPre',
          descrUnidad: '$_id.descrUnidad', ultInforme: {$toDouble: '$totalCantidad'}}},
            {$sort: {descrPlanta: 1, descrSeccion: 1, descrEquipo: 1, tipoLub: 1, descrLubricante: 1, descrUnidad: 1}}]`}

        if(2>1){
          let {data} = await this.props.allPlantaRtes3.refetch(argsBuscarPl)
          let estructura1 = await data.allPlantaRtes
          for(let ii=0; ii<estructura1.length; ii++){
            let nomLub = estructura1[ii].descrLubricante, nomPla = estructura1[ii].descrPlanta, nomSec = estructura1[ii].descrSeccion, nomEq = estructura1[ii].descrEquipo
            let indexLub = 0
            lubricantes.forEach(async (elemento, iii) => {
              if(lubricantes[iii][0].lubricante===nomLub && lubricantes[iii][0].planta===nomPla && lubricantes[iii][0].seccion===nomSec && lubricantes[iii][0].equipo===nomEq){
                indexLub = iii
              }
            })
            let cantidadLub=0
            if(estructura1[ii].tipoLub==='Aceite'){
              if(estructura1[ii].descrUnidad==='Galón' || estructura1[ii].descrUnidad==='Galon' || estructura1[ii].descrUnidad==='galón' || estructura1[ii].descrUnidad==='galon'){
                cantidadLub = estructura1[ii].ultInforme
              }else{
                switch(estructura1[ii].descrUnidad){
                  case 'Litros':
                    cantidadLub = estructura1[ii].ultInforme*0.264;
                    break
                  case 'Mililitro':
                    cantidadLub = estructura1[ii].ultInforme*0.00264;
                    break
                  case 'Onza':
                    cantidadLub = estructura1[ii].ultInforme*0.0078125;
                    break
                  case 'Gramos':
                    cantidadLub = estructura1[ii].ultInforme/3657.14826;
                  break
                }
              }
            }else{
              if(estructura1[ii].tipoLub==='Grasa'){
                if(estructura1[ii].descrUnidad==='Gramos' || estructura1[ii].descrUnidad==='gramos'){
                  cantidadLub = estructura1[ii].ultInforme/1000
                }else{
                  switch(estructura1[ii].descrUnidad){
                    case 'Onza':
                      cantidadLub = estructura1[ii].ultInforme*0.0283495;
                      break
                    case 'Mililitro':
                      cantidadLub = estructura1[ii].ultInforme/1000;
                      break
                    case 'Litros':
                      cantidadLub = estructura1[ii].ultInforme;
                      break
                  }
                }
              }else{

              }
            }
            if(cantidadLub>0){
              let cantidadMes=0
              let cantidadAnual=0
              let indexFrec = -1
              if(estructura1[ii].descrFrecuencia==='Predictiva'){
                indexFrec = allFrecuencia.findIndex( frecuencia => frecuencia.descrFrecuencia===estructura1[ii].descrFrecuenciaPre )
              }else{
                indexFrec = allFrecuencia.findIndex( frecuencia => frecuencia.descrFrecuencia===estructura1[ii].descrFrecuencia )
              }
              if(indexFrec!==-1){
                if(allFrecuencia[indexFrec].tipoFrecuencia!=='Km'){
                  if(allFrecuencia[indexFrec].tipoFrecuencia==='Calendario'){
                    cantidadMes=(cantidadLub*30)/allFrecuencia[indexFrec].cantidad
                  }else{
                    cantidadMes=(cantidadLub*720)/allFrecuencia[indexFrec].cantidad
                  }
                }
                cantidadAnual=cantidadMes*12
              }
              lubricantes[indexLub][0].mensual=lubricantes[indexLub][0].mensual + cantidadMes
              lubricantes[indexLub][0].anual=lubricantes[indexLub][0].anual + cantidadAnual
              
            }
          }
          lubricantes.forEach((elemento2, ii) => {
            argsLinea=this.crearLinea('ANEXOS','CONSUMO DE LUBRICANTES',nombreUsuario,'','','',elemento2[0].planta,elemento2[0].seccion,elemento2[0].equipo,'','',elemento2[0].tipo,elemento2[0].lubricante,elemento2[0].unidad,'','','','','','','',parseFloat(elemento2[0].total).toFixed(2),parseFloat(elemento2[0].mensual).toFixed(2),parseFloat(elemento2[0].anual).toFixed(2),0,0)
            reportes.push(argsLinea)
          })
        }

        // ***** CANTIDAD DE PROTECTORES POR ESPESANTE ***************************

        argsBuscarPl = {tipoqry: `[
          {"$unwind": "$secciones"},
          {"$unwind": "$secciones.equipos"},
          {"$unwind": "$secciones.equipos.componentes"},
          {"$unwind": "$secciones.equipos.componentes.mecanismos"},
          {$match: {'secciones.equipos.componentes.mecanismos.tipoLub': 'Grasa'}},
          {$project: {_id: 1,
            descrEmpresa: 1, codPlanta: 1, descrPlanta: 1,
            codSeccion: '$secciones.codSeccion', descrSeccion: '$secciones.descrSeccion',
            codEquipo: '$secciones.equipos.codEquipo', descrEquipo: '$secciones.equipos.descrEquipo',
            codComponente: '$secciones.equipos.componentes.codComponente',
            descrComponente: '$secciones.equipos.componentes.descrComponente',
            descrMecanismo: '$secciones.equipos.componentes.mecanismos.descrMecanismo',
            descrAplicacion: '$secciones.equipos.componentes.mecanismos.descrAplicacion'
          }}, {$match: {${argsBuscar}}}, 
          {$group: {_id: {descrPlanta: '$descrPlanta', descrSeccion: '$descrSeccion', descrEquipo: '$descrEquipo', 
          descrAplicacion: '$descrAplicacion'}, count: { $sum: 1 }}},
          {$project: {descrPlanta: '$_id.descrPlanta', descrSeccion: '$_id.descrSeccion', descrEquipo: '$_id.descrEquipo', descrAplicacion: '$_id.descrAplicacion', ultInforme: {$toInt: '$count'}}},
            {$sort: {descrPlanta: 1, descrSeccion: 1, descrEquipo: 1, descrAplicacion: 1}}]`}

        if(2>1){
          let {data} = await this.props.allPlantaRtes3.refetch(argsBuscarPl)
          let estructura1 = await data.allPlantaRtes
          for(let ii=0; ii<estructura1.length; ii++){
            let indexAp = allAplicacion.findIndex( aplicacion => aplicacion.descrAplicacion===estructura1[ii].descrAplicacion)
            let numGraseras=1
            if(indexAp!==-1){
              protectores.forEach(async (elemento, iii) => {
                if(protectores[iii][0].espesante===estructura1[ii].descrAplicacion && protectores[iii][0].planta===estructura1[ii].descrPlanta && protectores[iii][0].graseras===1){
                  numGraseras = 0
                }
              })
              protectores1 = [{planta:estructura1[ii].descrPlanta, seccion:estructura1[ii].descrSeccion, equipo:estructura1[ii].descrEquipo, color:allAplicacion[indexAp].color, espesante:estructura1[ii].descrAplicacion, puntos:estructura1[ii].ultInforme, graseras: numGraseras}]
              protectores.push(protectores1)
            }
          }
        }

        protectores.forEach((elemento2, ii) => {
          argsLinea=this.crearLinea('ANEXOS','PROTECTORES Y PISTOLAS ENGRASADORAS',nombreUsuario,'','','',elemento2[0].planta,elemento2[0].seccion,elemento2[0].equipo,'','','','','','','',elemento2[0].espesante,'',elemento2[0].color,'','',elemento2[0].graseras,0,0,elemento2[0].puntos,0)
          reportes.push(argsLinea)
        })

        // ***** CANTIDAD DE ACEITERAS POR APLICACION ***************************

        argsBuscarPl = {tipoqry: `[
          {"$unwind": "$secciones"},
          {"$unwind": "$secciones.equipos"},
          {"$unwind": "$secciones.equipos.componentes"},
          {"$unwind": "$secciones.equipos.componentes.mecanismos"},
          {$match: {'secciones.equipos.componentes.mecanismos.tipoLub': 'Aceite'}},
          {$project: {_id: 1,
            descrEmpresa: 1, codPlanta: 1, descrPlanta: 1,
            codSeccion: '$secciones.codSeccion', descrSeccion: '$secciones.descrSeccion',
            codEquipo: '$secciones.equipos.codEquipo', descrEquipo: '$secciones.equipos.descrEquipo',
            codComponente: '$secciones.equipos.componentes.codComponente',
            descrComponente: '$secciones.equipos.componentes.descrComponente',
            descrMecanismo: '$secciones.equipos.componentes.mecanismos.descrMecanismo',
            descrAplicacion: '$secciones.equipos.componentes.mecanismos.descrAplicacion'
          }}, {$match: {${argsBuscar}}}, 
          {$group: {_id: {descrPlanta: '$descrPlanta', descrSeccion: '$descrSeccion', descrEquipo: '$descrEquipo', descrAplicacion: '$descrAplicacion'}, count: { $sum: 1 }}},
          {$project: {descrPlanta: '$_id.descrPlanta', descrSeccion: '$_id.descrSeccion', descrEquipo: '$_id.descrEquipo', descrAplicacion: '$_id.descrAplicacion', ultInforme: {$toInt: '$count'}}},
            {$sort: {descrPlanta: 1, descrSeccion: 1, descrEquipo: 1, descrAplicacion: 1}}]`}

        if(2>1){
          let {data} = await this.props.allPlantaRtes3.refetch(argsBuscarPl)
          let estructura1 = await data.allPlantaRtes
          for(let ii=0; ii<estructura1.length; ii++){
            let indexAp = allAplicacion.findIndex( aplicacion => aplicacion.descrAplicacion===estructura1[ii].descrAplicacion )
            let numAceiteras=1
            if(indexAp!==-1){
              aceiteras.forEach(async (elemento, iii) => {
                if(aceiteras[iii][0].aplicacion===estructura1[ii].descrAplicacion && aceiteras[iii][0].planta===estructura1[ii].descrPlanta && aceiteras[iii][0].aceiteras===1){
                  numAceiteras = 0
                }
              })
              aceiteras1 = [{planta:estructura1[ii].descrPlanta, seccion:estructura1[ii].descrSeccion, equipo:estructura1[ii].descrEquipo, color:allAplicacion[indexAp].color, aplicacion:estructura1[ii].descrAplicacion, puntos:estructura1[ii].ultInforme, aceiteras: numAceiteras}]
              aceiteras.push(aceiteras1)
            }
          }
       }

        aceiteras.forEach((elemento2, ii) => {
          argsLinea=this.crearLinea('ANEXOS','ACEITERAS',nombreUsuario,'','','',elemento2[0].planta,elemento2[0].seccion,elemento2[0].equipo,'','','','','','','',elemento2[0].aplicacion,'',elemento2[0].color,'','',elemento2[0].aceiteras,0,0,elemento2[0].puntos,0)
          reportes.push(argsLinea)
        })


        // ***** HORAS HOMBRE POR TAREA POR MES Y AÑO ***************************

        argsBuscarPl = {tipoqry: `[
          {"$unwind": "$secciones"},
          {"$unwind": "$secciones.equipos"},
          {"$unwind": "$secciones.equipos.componentes"},
          {"$unwind": "$secciones.equipos.componentes.mecanismos"},
          {"$unwind": "$secciones.equipos.componentes.mecanismos.programacion"},
          {$match: {'secciones.equipos.componentes.mecanismos.programacion.minutos': {$ne: ""}}},
          {$project: {_id: 1,
            descrEmpresa: 1, codPlanta: 1, descrPlanta: 1,
            codSeccion: '$secciones.codSeccion', descrSeccion: '$secciones.descrSeccion',
            codEquipo: '$secciones.equipos.codEquipo', descrEquipo: '$secciones.equipos.descrEquipo',
            codComponente: '$secciones.equipos.componentes.codComponente',
            descrComponente: '$secciones.equipos.componentes.descrComponente',
            descrMecanismo: '$secciones.equipos.componentes.mecanismos.descrMecanismo',
            descrTarea: '$secciones.equipos.componentes.mecanismos.programacion.descrTarea',
            descrFrecuencia: '$secciones.equipos.componentes.mecanismos.programacion.descrFrecuencia',
            descrFrecuenciaPre: '$secciones.equipos.componentes.mecanismos.programacion.descrFrecuenciaPre',
            minutos: '$secciones.equipos.componentes.mecanismos.programacion.minutos'
          }}, {$match: {${argsBuscar}}}, 
          {$group: {_id: {descrPlanta: '$descrPlanta', descrSeccion: '$descrSeccion', descrEquipo: '$descrEquipo', descrTarea: '$descrTarea', descrFrecuencia: '$descrFrecuencia', 
                    descrFrecuenciaPre: '$descrFrecuenciaPre'},
                    totalCantidad: {$sum: {$toDouble: '$minutos'}}}},
          {$project: {descrPlanta: '$_id.descrPlanta', descrSeccion: '$_id.descrSeccion', descrEquipo: '$_id.descrEquipo', descrTarea: '$_id.descrTarea', 
          descrFrecuencia: '$_id.descrFrecuencia', descrFrecuenciaPre: '$_id.descrFrecuenciaPre',
          ultInforme: {$toDouble: '$totalCantidad'}}},
            {$sort: {descrPlanta: 1, descrSeccion: 1, descrEquipo: 1, descrTarea: 1}}]`}

        if(2>1){
          let {data} = await this.props.allPlantaRtes3.refetch(argsBuscarPl)
          let estructura1 = await data.allPlantaRtes
          for(let ii=0; ii<estructura1.length; ii++){
            let nomTa = estructura1[ii].descrTarea, nomPla = estructura1[ii].descrPlanta, nomSec = estructura1[ii].descrSeccion, nomEq = estructura1[ii].descrEquipo
            let indexTa = -1
            tareas.forEach(async (elemento, iii) => {
              if(tareas[iii][0].tarea===nomTa && tareas[iii][0].planta===nomPla && tareas[iii][0].seccion===nomSec && tareas[iii][0].equipo===nomEq){
                indexTa = iii
              }
            })
            let cantidadHoras=0
            if(indexTa!==-1 && estructura1[ii].ultInforme>0){
              cantidadHoras=estructura1[ii].ultInforme/60
              let cantidadMes=0
              let cantidadAnual=0
              let indexFrec = -1
              if(estructura1[ii].descrFrecuencia==='Predictiva'){
                indexFrec = allFrecuencia.findIndex( frecuencia => frecuencia.descrFrecuencia===estructura1[ii].descrFrecuenciaPre )
              }else{
                indexFrec = allFrecuencia.findIndex( frecuencia => frecuencia.descrFrecuencia===estructura1[ii].descrFrecuencia )
              }
              if(indexFrec!==-1){
                if(allFrecuencia[indexFrec].tipoFrecuencia!=='Km'){
                  if(allFrecuencia[indexFrec].tipoFrecuencia==='Calendario'){
                    cantidadMes=(cantidadHoras*30)/allFrecuencia[indexFrec].cantidad
                  }else{
                    cantidadMes=(cantidadHoras*720)/allFrecuencia[indexFrec].cantidad
                  }
                  cantidadAnual=cantidadMes*12
                }
              }
              tareas[indexTa][0].mensual=tareas[indexTa][0].mensual + cantidadMes
              tareas[indexTa][0].anual=tareas[indexTa][0].anual + cantidadAnual
            }
          }
        }

        tareas.forEach((elemento2, ii) => {
          argsLinea=this.crearLinea('ANEXOS','HORAS-HOMBRE POR TAREA',nombreUsuario,'','','',elemento2[0].planta,elemento2[0].seccion,elemento2[0].equipo,'','','','','','',elemento2[0].tarea,'','','','','',0,parseFloat(elemento2[0].mensual).toFixed(1),parseFloat(elemento2[0].anual).toFixed(1),0,0)
          reportes.push(argsLinea)
        })


        // ***** HORAS HOMBRE POR I / O POR MES Y AÑO ***************************

        argsBuscarPl = {tipoqry: `[
          {"$unwind": "$secciones"},
          {"$unwind": "$secciones.equipos"},
          {"$unwind": "$secciones.equipos.componentes"},
          {"$unwind": "$secciones.equipos.componentes.mecanismos"},
          {"$unwind": "$secciones.equipos.componentes.mecanismos.programacion"},
          {$match: {'secciones.equipos.componentes.mecanismos.programacion.minutos': {$ne: ""},
                    'secciones.equipos.componentes.mecanismos.programacion.modoTarea': {$ne: ""}}},
          {$project: {_id: 1,
            descrEmpresa: 1, codPlanta: 1, descrPlanta: 1,
            codSeccion: '$secciones.codSeccion', descrSeccion: '$secciones.descrSeccion',
            codEquipo: '$secciones.equipos.codEquipo', descrEquipo: '$secciones.equipos.descrEquipo',
            codComponente: '$secciones.equipos.componentes.codComponente',
            descrComponente: '$secciones.equipos.componentes.descrComponente',
            descrMecanismo: '$secciones.equipos.componentes.mecanismos.descrMecanismo',
            modoTarea: '$secciones.equipos.componentes.mecanismos.programacion.modoTarea',
            descrFrecuencia: '$secciones.equipos.componentes.mecanismos.programacion.descrFrecuencia',
            descrFrecuenciaPre: '$secciones.equipos.componentes.mecanismos.programacion.descrFrecuenciaPre',
            minutos: '$secciones.equipos.componentes.mecanismos.programacion.minutos'
          }}, {$match: {${argsBuscar}}}, 
          {$group: {_id: {descrPlanta: '$descrPlanta', descrSeccion: '$descrSeccion', descrEquipo: '$descrEquipo', modoTarea: '$modoTarea', descrFrecuencia: '$descrFrecuencia', 
                    descrFrecuenciaPre: '$descrFrecuenciaPre'},
                    totalCantidad: {$sum: {$toDouble: '$minutos'}}}},
          {$project: {descrPlanta: '$_id.descrPlanta', descrSeccion: '$_id.descrSeccion', descrEquipo: '$_id.descrEquipo', modoTarea: '$_id.modoTarea', 
          descrFrecuencia: '$_id.descrFrecuencia', descrFrecuenciaPre: '$_id.descrFrecuenciaPre',
          ultInforme: {$toDouble: '$totalCantidad'}}},
            {$sort: {descrPlanta: 1, descrSeccion: 1, descrEquipo: 1, modoTarea: 1}}]`}

        if(2>1){
          let {data} = await this.props.allPlantaRtes3.refetch(argsBuscarPl)
          let estructura1 = await data.allPlantaRtes
          let indexTa = -1
          for(let ii=0; ii<estructura1.length; ii++){
            let nomPla = estructura1[ii].descrPlanta, nomSec = estructura1[ii].descrSeccion, nomEq = estructura1[ii].descrEquipo
            modo.forEach(async (elemento, iii) => {
              if(estructura1[ii].modoTarea==='I'){
                if(modo[iii][0].modo==='Operando' && modo[iii][0].planta===nomPla && modo[iii][0].seccion===nomSec && modo[iii][0].equipo===nomEq){
                  indexTa = iii
                }
              }else{
                if(modo[iii][0].modo==='En parada' && modo[iii][0].planta===nomPla && modo[iii][0].seccion===nomSec && modo[iii][0].equipo===nomEq){
                  indexTa = iii
                }
              }
            })
            let cantidadHoras=0

            if(indexTa!==-1 && estructura1[ii].ultInforme>0){
              cantidadHoras=estructura1[ii].ultInforme/60
              let cantidadMes=0
              let cantidadAnual=0
              let indexFrec = -1
              if(estructura1[ii].descrFrecuencia==='Predictiva'){
                indexFrec = allFrecuencia.findIndex( frecuencia => frecuencia.descrFrecuencia===estructura1[ii].descrFrecuenciaPre )
              }else{
                indexFrec = allFrecuencia.findIndex( frecuencia => frecuencia.descrFrecuencia===estructura1[ii].descrFrecuencia )
              }
              if(indexFrec!==-1){
                if(allFrecuencia[indexFrec].tipoFrecuencia!=='Km'){
                  if(allFrecuencia[indexFrec].tipoFrecuencia==='Calendario'){
                    cantidadMes=(cantidadHoras*30)/allFrecuencia[indexFrec].cantidad
                  }else{
                    cantidadMes=(cantidadHoras*720)/allFrecuencia[indexFrec].cantidad
                  }
                  cantidadAnual=cantidadMes*12
                }
              }
              modo[indexTa][0].mensual=modo[indexTa][0].mensual + cantidadMes
              modo[indexTa][0].anual=modo[indexTa][0].anual + cantidadAnual
            }
          }
        }

        modo.forEach((elemento2, ii) => {
          argsLinea=this.crearLinea('ANEXOS','HORAS-HOMBRE POR MODO DE TAREA',nombreUsuario,'','','',elemento2[0].planta,elemento2[0].seccion,elemento2[0].equipo,'','','','','','','','','','',elemento2[0].modo,'',0,parseFloat(elemento2[0].mensual).toFixed(1),parseFloat(elemento2[0].anual).toFixed(1),0,0)
          reportes.push(argsLinea)
        })

        // ***** HORAS HOMBRE POR SISO POR MES Y AÑO ***************************

        argsBuscarPl = {tipoqry: `[
          {"$unwind": "$secciones"},
          {"$unwind": "$secciones.equipos"},
          {"$unwind": "$secciones.equipos.componentes"},
          {"$unwind": "$secciones.equipos.componentes.mecanismos"},
          {"$unwind": "$secciones.equipos.componentes.mecanismos.programacion"},
          {$match: {'secciones.equipos.componentes.mecanismos.programacion.minutos': {$ne: ""},
                    'secciones.equipos.componentes.mecanismos.programacion.requiereSISO': {$ne: ""}}},
          {$project: {_id: 1,
            descrEmpresa: 1, codPlanta: 1, descrPlanta: 1,
            codSeccion: '$secciones.codSeccion', descrSeccion: '$secciones.descrSeccion',
            codEquipo: '$secciones.equipos.codEquipo', descrEquipo: '$secciones.equipos.descrEquipo',
            codComponente: '$secciones.equipos.componentes.codComponente',
            descrComponente: '$secciones.equipos.componentes.descrComponente',
            descrMecanismo: '$secciones.equipos.componentes.mecanismos.descrMecanismo',
            requiereSISO: '$secciones.equipos.componentes.mecanismos.programacion.requiereSISO',
            descrFrecuencia: '$secciones.equipos.componentes.mecanismos.programacion.descrFrecuencia',
            descrFrecuenciaPre: '$secciones.equipos.componentes.mecanismos.programacion.descrFrecuenciaPre',
            minutos: '$secciones.equipos.componentes.mecanismos.programacion.minutos'
          }}, {$match: {${argsBuscar}}}, 
          {$group: {_id: {descrPlanta: '$descrPlanta', descrSeccion: '$descrSeccion', descrEquipo: '$descrEquipo', requiereSISO: '$requiereSISO', descrFrecuencia: '$descrFrecuencia', 
                    descrFrecuenciaPre: '$descrFrecuenciaPre'},
                    totalCantidad: {$sum: {$toDouble: '$minutos'}}}},
          {$project: {descrPlanta: '$_id.descrPlanta', descrSeccion: '$_id.descrSeccion', descrEquipo: '$_id.descrEquipo', requiereSISO: '$_id.requiereSISO', 
          descrFrecuencia: '$_id.descrFrecuencia', descrFrecuenciaPre: '$_id.descrFrecuenciaPre',
          ultInforme: {$toDouble: '$totalCantidad'}}},
            {$sort: {descrPlanta: 1, descrSeccion: 1, descrEquipo: 1, requiereSISO: 1}}]`}

        if(2>1){
          let {data} = await this.props.allPlantaRtes3.refetch(argsBuscarPl)
          let estructura1 = await data.allPlantaRtes
          let indexTa = -1
          for(let ii=0; ii<estructura1.length; ii++){
            let nomPla = estructura1[ii].descrPlanta, nomSec = estructura1[ii].descrSeccion, nomEq = estructura1[ii].descrEquipo
            siso.forEach(async (elemento, iii) => {
              if(estructura1[ii].requiereSISO==='S' || estructura1[ii].requiereSISO==='Si' || estructura1[ii].requiereSISO==='SI' || estructura1[ii].requiereSISO==='si'){
                if( siso[iii][0].siso==='Requiere SISO' && siso[iii][0].planta===nomPla && siso[iii][0].seccion===nomSec && siso[iii][0].equipo===nomEq){
                  indexTa = iii
                }
              }else{
                if(siso[iii][0].siso==='No requiere SISO' && siso[iii][0].planta===nomPla && siso[iii][0].seccion===nomSec && siso[iii][0].equipo===nomEq){
                  indexTa = iii
                }
              }
            })
            let cantidadHoras=0

            if(indexTa!==-1 && estructura1[ii].ultInforme>0){
              cantidadHoras=estructura1[ii].ultInforme/60
              let cantidadMes=0
              let cantidadAnual=0
              let indexFrec = -1
              if(estructura1[ii].descrFrecuencia==='Predictiva'){
                indexFrec = allFrecuencia.findIndex( frecuencia => frecuencia.descrFrecuencia===estructura1[ii].descrFrecuenciaPre )
              }else{
                indexFrec = allFrecuencia.findIndex( frecuencia => frecuencia.descrFrecuencia===estructura1[ii].descrFrecuencia )
              }
              if(indexFrec!==-1){
                if(allFrecuencia[indexFrec].tipoFrecuencia!=='Km'){
                  if(allFrecuencia[indexFrec].tipoFrecuencia==='Calendario'){
                    cantidadMes=(cantidadHoras*30)/allFrecuencia[indexFrec].cantidad
                  }else{
                    cantidadMes=(cantidadHoras*720)/allFrecuencia[indexFrec].cantidad
                  }
                  cantidadAnual=cantidadMes*12
                }
              }
              siso[indexTa][0].mensual=siso[indexTa][0].mensual + cantidadMes
              siso[indexTa][0].anual=siso[indexTa][0].anual + cantidadAnual
            }
          }
        }

        siso.forEach((elemento2, ii) => {
          argsLinea=this.crearLinea('ANEXOS','HORAS-HOMBRE POR TIPO DE RIESGO',nombreUsuario,'','','',elemento2[0].planta,elemento2[0].seccion,elemento2[0].equipo,'','','','','','','','','','','',elemento2[0].siso,0.0,parseFloat(elemento2[0].mensual).toFixed(1),parseFloat(elemento2[0].anual).toFixed(1),0,0)
          reportes.push(argsLinea)
        })

        reportes.forEach((elemento2, ii) => {
          argsUpdEmp = {
            "_id": idEmpresa,
            "descrEmpresa": descrEmpresa,
            "rutaLogo": rutaLogo,
            "tipo": elemento2.tipo,
            "subTipo": elemento2.subTipo,
            "usuario": elemento2.usuario,
            "creado": fechaHoraHoy,
            "desde": elemento2.desde,
            "hasta": elemento2.hasta,
            "descrPlanta": elemento2.descrPlanta,
            "descrSeccion": elemento2.descrSeccion,
            "descrEquipo": elemento2.descrEquipo,
            "descrComponente": elemento2.descrComponente,
            "descrMecanismo": elemento2.descrMecanismo,
            "tipoLub": elemento2.tipoLub,
            "descrLubricante": elemento2.descrLubricante,
            "descrUnidad": elemento2.descrUnidad,
            "descrMetodo": elemento2.descrMetodo,
            "descrTarea": elemento2.descrTarea,
            "descrAplicacion": elemento2.descrAplicacion,
            "tipoHallazgo": elemento2.tipoHallazgo,
            "color": elemento2.color,
            "modo": elemento2.modo,
            "riesgo": elemento2.riesgo,
            "cantTotal": elemento2.cantTotal,
            "cantMensual": elemento2.cantMensual,
            "cantAnual": elemento2.cantAnual,
            "puntos": elemento2.puntos,
            "minutos": elemento2.minutos
          }
          actEmpresa.push(argsUpdEmp)
        })
console.log()
//         actEmpresa.forEach((elementoRep, ii) => {
//           actEmpactEmpresaresaMany.push(elementoRep)
//         })
//         actEmpresaMany1.push({empresa: actEmpresaMany})
//         let numDocCRUD = 0
//         let totDocCRUD = actEmpresaMany1.length
//         let argsCrud = []
//         let crudColecc = []
//         for(let iii=0; iii<totDocCRUD; iii++){
//           argsCrud.push({ctrlCampo: 'NO_CRUD'})
//         }
//         for(let iii=0; iii<totDocCRUD; iii++){
//           crudColecc.push(this.props.editEmpresaMany)
//         }

//         argsCrud[numDocCRUD] = actEmpresaMany1[0]
//         argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
//         argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'

//         crudColecc[numDocCRUD] = this.props.editEmpresaMany
//         if(totDocCRUD>0){
//           await this.updColeccInd(crudColecc, argsCrud, totDocCRUD)
//         }
      }  
    }
  }  

  let argsBuscarPl = {tipoqry: `[{$match: {anexos: 'S'}},
      {"$unwind": "$reportes"},
      {$project: {_id: {$concat: ['$reportes.descrPlanta', '$reportes.descrSeccion', '$reportes.descrEquipo', '$reportes.subTipo', '$reportes.descrLubricante', '$reportes.descrAplicacion', '$reportes.descrTarea', '$reportes.modo', '$reportes.riesgo']}, 
        descrEmpresa: 1, logo: 1, rutaLogo: 1, descrPlanta: '$reportes.descrPlanta', descrSeccion: '$reportes.descrSeccion', descrEquipo: '$reportes.descrEquipo', tipo: '$reportes.tipo', subTipo: '$reportes.subTipo', usuario: '$reportes.usuario', 
        tipoLub: '$reportes.tipoLub', descrLubricante: '$reportes.descrLubricante',
        descrUnidad: '$reportes.descrUnidad', descrTarea: '$reportes.descrTarea', descrAplicacion: '$reportes.descrAplicacion', 
        color: '$reportes.color', modo: '$reportes.modo', riesgo: '$reportes.riesgo', cantTotal: '$reportes.cantTotal',
        cantMensual: '$reportes.cantMensual', cantAnual: '$reportes.cantAnual', puntos: '$reportes.puntos', minutos: '$reportes.minutos'
      }}, {$match: {tipo: 'ANEXOS', usuario: '${nombreUsuario}'}}]`}

    if(argsBuscarPl!==''){
      // let {data} = await this.props.allEmpresaInd.refetch(argsBuscarPl)
      // let estructura = await data.allEmpresaInd
      let estructura=actEmpresa
      if(estructura.length>0){       
        let list = estructura
        let xlsString = []
        let xlsString1 = []
        xlsString1 = ['Empresa', 'Logo', 'Planta', 'Sección', 'Equipo', 'Tipo', 'Subtipo', 'usuario', 'Tipo lub', 'Lubricante', 'Unidad', 'Tarea',
          'Aplicación', 'Espesante', 'Color', 'Modo de ejecución tarea', 'Tipo de riesgo', 'Volumen total (Gal)', 'Consumo mensual (Gal)', 'Consumo anual (Gal)', 'Volumen total (Kg)', 'Consumo mensual (Kg)', 'Consumo anual (Kg)', 'Mensual (HH)', 'Anual (HH)', 'Puntos', 'Minutos', 'Protectores', 'Graseras', 'Aceiteras', 'Logo_URL']
        xlsString.push(xlsString1)
        for (let iiii=0;iiii<list.length;iiii++){
          if(list[iiii].subTipo==='CONSUMO DE LUBRICANTES'){
            if(list[iiii].tipoLub==='Aceite'){
              xlsString1 = [list[iiii].descrEmpresa, list[iiii].logo, list[iiii].descrPlanta, list[iiii].descrSeccion, list[iiii].descrEquipo, 
              list[iiii].tipo, list[iiii].subTipo, 
              list[iiii].usuario, list[iiii].tipoLub, list[iiii].descrLubricante, list[iiii].descrUnidad, 
              list[iiii].descrTarea, list[iiii].descrAplicacion, '', list[iiii].color, list[iiii].modo, 
              list[iiii].riesgo, list[iiii].cantTotal, list[iiii].cantMensual, list[iiii].cantAnual, 0, 0, 0, 0, 0,
              list[iiii].puntos, list[iiii].minutos, 0, 0, 0, list[iiii].rutaLogo]
            }else{
              xlsString1 = [list[iiii].descrEmpresa, list[iiii].logo, list[iiii].descrPlanta, list[iiii].descrSeccion, list[iiii].descrEquipo, 
              list[iiii].tipo, list[iiii].subTipo, 
              list[iiii].usuario, list[iiii].tipoLub, list[iiii].descrLubricante, list[iiii].descrUnidad, 
              list[iiii].descrTarea, list[iiii].descrAplicacion, '', list[iiii].color, list[iiii].modo, 
              list[iiii].riesgo, 0, 0, 0, list[iiii].cantTotal, list[iiii].cantMensual, list[iiii].cantAnual, 0, 0,
              list[iiii].puntos, list[iiii].minutos, 0, 0, 0, list[iiii].rutaLogo]
            }
          }
          if(list[iiii].subTipo==='PROTECTORES Y PISTOLAS ENGRASADORAS'){
            xlsString1 = [list[iiii].descrEmpresa, list[iiii].logo, list[iiii].descrPlanta, list[iiii].descrSeccion, list[iiii].descrEquipo, 
            list[iiii].tipo, list[iiii].subTipo, 
            list[iiii].usuario, list[iiii].tipoLub, list[iiii].descrLubricante, list[iiii].descrUnidad, 
            list[iiii].descrTarea, '', list[iiii].descrAplicacion, list[iiii].color, list[iiii].modo, 
            list[iiii].riesgo, 0, list[iiii].cantMensual, list[iiii].cantAnual, 0, 0, 0, 0, 0,
            0, list[iiii].minutos, list[iiii].puntos, list[iiii].cantTotal, 0, list[iiii].rutaLogo]
          }
          if(list[iiii].subTipo==='ACEITERAS'){
            xlsString1 = [list[iiii].descrEmpresa, list[iiii].logo, list[iiii].descrPlanta, list[iiii].descrSeccion, list[iiii].descrEquipo, 
            list[iiii].tipo, list[iiii].subTipo, 
            list[iiii].usuario, list[iiii].tipoLub, list[iiii].descrLubricante, list[iiii].descrUnidad, 
            list[iiii].descrTarea, list[iiii].descrAplicacion, '', list[iiii].color, list[iiii].modo, 
            list[iiii].riesgo, 0, list[iiii].cantMensual, list[iiii].cantAnual, 0, 0, 0, 0, 0,
            list[iiii].puntos, list[iiii].minutos, 0, 0, list[iiii].cantTotal, list[iiii].rutaLogo]
          }
          if(list[iiii].subTipo==='HORAS-HOMBRE POR TAREA' || list[iiii].subTipo==='HORAS-HOMBRE POR MODO DE TAREA'
          || list[iiii].subTipo==='HORAS-HOMBRE POR TIPO DE RIESGO'){
            xlsString1 = [list[iiii].descrEmpresa, list[iiii].logo, list[iiii].descrPlanta, list[iiii].descrSeccion, list[iiii].descrEquipo, 
            list[iiii].tipo, list[iiii].subTipo, 
            list[iiii].usuario, list[iiii].tipoLub, list[iiii].descrLubricante, list[iiii].descrUnidad, 
            list[iiii].descrTarea, list[iiii].descrAplicacion, '', list[iiii].color, list[iiii].modo, 
            list[iiii].riesgo, list[iiii].cantTotal, 0, 0, 0, 0, 0, list[iiii].cantMensual, list[iiii].cantAnual,
            list[iiii].puntos, list[iiii].minutos, 0, 0, 0, list[iiii].rutaLogo]
          }

          xlsString.push(xlsString1)

          if(iiii===list.length-1){
            var wb = XLSX.utils.book_new();

            wb.Props = {
              Title: "SheetJS Tutorial",
              Subject: "Test",
              Author: "Red Stapler",
              CreatedDate: new Date(2017,12,19)
            };

            wb.SheetNames.push("Anexos");

            let ws_data = xlsString;

            let ws = XLSX.utils.aoa_to_sheet(ws_data);
            wb.Sheets["Anexos"] = ws;
            let wbout = XLSX.write(wb, {bookType:'xlsx',  type: 'binary'});
            function s2ab(s) { 
              let buf = new ArrayBuffer(s.length); //convert s to arrayBuffer
              let view = new Uint8Array(buf);  //create uint8array as viewer
              for (let i=0; i<s.length; i++) view[i] = s.charCodeAt(i) & 0xFF; //convert to octet
              return buf;    
            }
            saveAs(new Blob([s2ab(wbout)],{type:"application/octet-stream"}), 'Anexos_carta.xlsx');
  //FIN Exportar a XLS
          }
        }

        document.body.style.cursor = 'default'

        // await this.props.allOrdenRtes.refetch()
        this.setState({open: false, confirmaAct: false})
      }
    }

  }

  render(){
    const {listCL, listImg, permiteBtn1, permiteBtn2, confirmaAct, open} = this.state;
    let mensaje1 = "IMPRIMIR CARTA DE LUBRICACION"
    let imgIcon1 = "images/archivo_32.png"
    let mensaje2 = "IMPRIMIR ANEXOS"
    
  let list = []
  if(listCL){
    list = listCL
    for(let i=0; i<listCL.length; i++){
      list[i].idPlanta = i
    }
  }

  let list2 = []
  if(listImg){
    list2 = listImg
    for(let i=0; i<listImg.length; i++){
      list2[i].idPlanta = i
    }
  }
  let slcm=""
  if(localStorage.getItem('userLogin')==="slcm@slcm.com"){
    slcm="slcm"
  }
  return (
    <div>
      <List selection>
        <TitDer list={this.props.list} textBoton1="Cartas de Lubricación" btnNuevo={"NO"} styles={this.props.styles}/>

        <div className='ui blue inverted raised segment' style={this.props.styles.backGr_1}>
          <Form name="form1" id="form1" onSubmit={confirmaAct?
            permiteBtn1?
              (ev)=>this.handleSubmit(ev, list, list2, this.props.args)
              :permiteBtn2?
                (ev)=>this.handleAnexos(ev, list, this.props.args)
                :()=>{}                
            :()=>{}}
          >
            <div className="ui three column stackable grid">
              <div className="row container">
                <div className="column" style={{width: '50%', paddingLeft: '1.2em'}}>
                  <Form.Field>
                    <ListaEmp styles={this.props.styles} list={this.props.list1}
                      handleChange={this.props.handleChange} />
                  </Form.Field>
                </div>
                {permiteBtn1 &&
                  <div className="column" style={{width: '18%', paddingTop: '0.3em'}}>
                    <EstaSeg7Btn mensaje1={mensaje1} imgIcon1={imgIcon1} 
                      open={open}
                      styles={this.props.styles} handleQuestionUpdDel={(ev)=>this.handleQuestionUpdDel(ev, "1")}/>
                  </div>
                }
                {/* {permiteBtn2 &&
                  <div className="column" style={{width: '18%', paddingTop: '0.3em'}}>
                    <EstaSeg7Btn mensaje2={mensaje2} imgIcon2={imgIcon1} 
                      open={open}
                      styles={this.props.styles} handleQuestionUpdDel={(ev)=>this.handleQuestionUpdDel(ev, "2")}/>
                  </div>
                } */}
                {localStorage.getItem('userLogin')==="slcm@slcm.com" &&
                  <div className="column" style={{width: '18%', paddingTop: '0.3em'}}>
                    <Button id="excel" name="excel" style={this.props.styles.confirmar} onClick={(ev)=>this.handleGenExc(ev, this.props.args)} fluid>
                      Excel anexos
                    </Button>
                  </div>
                } 
              </div>
            </div>
            <div style={{height: '40em', overflow: 'auto'}}>
              <table id="tabla" className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                <thead className=''>
                  <tr className=''>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '5%'}}>Planta</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '5%'}}>Sección</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '5%'}}>Equipo</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '8%'}}>Componente</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '8%'}}>Mecanismo</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '8%'}}>Aplicación/Espesante</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '8%'}}>Método</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '8%'}}>Tarea</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '8%'}}>Modo ejec. tarea</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '8%'}}>Requiere SISO</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '5%'}}>Frecuencia</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '8%'}}>Lubricante</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '5%'}}>Tipo</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '4%'}}>Puntos Lub</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '5%'}}>Clase Lub</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '5%'}}>Categ Lub</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '4%'}}>Grado</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '5%'}}>Tipo Grado</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '4%'}}>Api SAE</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '5%'}}>Rótulo</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '5%'}}>QR</th>
                  </tr>
                </thead>
                <ListaPl list={list}/>
              </table>
              <p></p>
            </div>
            <hr></hr>
          </Form>
        </div>
      </List>
    </div>
  )
  }
};

export default compose( 
  graphql(queries.query.allPlantaRtes, {name:'allPlantaRtes2',
    options: (props) => {return {variables: {tipoqry: `[{$match: {descrEmpresa: 'Seleccionar Empresa...'}}]`}}}}),
  graphql(queries.query.allPlantaRtes, {name:'allPlantaRtes3',
    options: (props) => {return {variables: {tipoqry: `[{$match: {descrEmpresa: 'Seleccionar Empresa...'}}]`}}}}),
  graphql(queries.query.allProducto, {name:'allProducto'}),
  // graphql(queries.query.allLubricante, {name:'allLubricante'}),
  // graphql(queries.query.allUnidad, {name:'allUnidad'}),
  graphql(queries.query.allFrecuencia, {name:'allFrecuencia'}),
  graphql(queries.query.allAplicacion, {name:'allAplicacion'}),
  graphql(queries.query.allUsuarios, {name:'allUsuarios'}),
  graphql(queries.query.allEmpresaRtes, {name:'allEmpresaRtes',
    options: (props) => {return {variables: {tipoqry: `[{$match: {'descrEmpresa': {$ne: 'Seleccionar Empresa...'}}}]`}}}}),
  graphql(queries.query.allEmpresaInd, {name:'allEmpresaInd',
    options: (props) => {return {variables: {tipoqry: `[{$match: {'descrEmpresa': {$ne: 'Seleccionar Empresa...'}}}]`}}}}),
  // graphql(queries.mutation.editEmpresa, {name:'editEmpresa'}),
  graphql(queries.mutation.editEmpresaMany, {name:'editEmpresaMany'}),
  graphql(queries.mutation.fecha, {name:'fecha'}),
  graphql(queries.query.allPlantaRtes, { name: 'allPlantaRtesC' }), // sin options
)(ConfImprCL2)

